/*
TABLE OF CONTENTS

START -- BYOG CUSTOM CODE
CUSTOM HTML
** Wait for HTML classes
** Insert header + nav
** Setup navigation items
** Remove products on any category
** Summary Page
*** Rewrite product titles from gbb-cart-1 personalization meta
** UI Update by step
** Save & Autofill Baby Name
** Event Handlers
** BYOG state helpers
Step 3 only: Hide products by style (boy/girl keywords)
** BYOG setup wrapper (runs on AJAX updates)
FOOTER STUFF
MASTER FLOW
START -- BYOG -- SOFT TOYS PERSONALISATION FILTER
START -- BYOG -- AUTO-ADD EMBROIDERY ADD-ON PRODUCTS (Soft Toys)
START -- BYOG -- AUTO-ADD ADD-ON PRODUCTS (Soft Toy Backpack - single product)
START -- BYOG -- DISABLE UNAVAILABLE COMBINATIONS
START -- BYOG -- PARENT CAPS PERSONALISATION FILTER
START -- BYOG -- AUTO-ADD NAME ON BACK ADD-ON (Mama & Dad Caps)
START -- BYOG -- P15 / P20 PERSONALISATION FILTER AND ADD-ON
*/

// --------------------------------------------------------------------
// START -- BYOG CUSTOM CODE

var byogCurrentStep = 1;
var byogSelectedStyle = null;

var byogEventsBound = false;

var BYOG_BABY_NAME_KEY = 'byog_baby_name';
var BYOG_BOXES_KEY = 'byog_boxes';

// -------------------------------------------
// CUSTOM HTML
// -------------------------------------------
var byogHeaderHTML = '\
<div class="byog-header">\
  <h1>Curate Your Dream Baby Gift</h1>\
  <div class="byog-steps-container">\
    <div class="byog-step" data-step="1">\
      <div class="byog-step-img"><img src="" /></div>\
      <div class="byog-step-text">\
        <p><span>Step 1:</span><span class="desktop">Select Baby Boy, Baby Girl or Neutral Tones</span><span class="mobile">Select Baby Boy, <br />Baby Girl or Neutral Tones</span></p>\
      </div>\
    </div>\
    <div class="byog-step" data-step="2">\
      <div class="byog-step-img"><img src="" /></div>\
      <div class="byog-step-text">\
        <p><span>Step 2:</span><span class="desktop">Select your perfect collection of gifts</span><span class="mobile">Select your<br />perfect collection of gifts</span></p>\
      </div>\
    </div>\
    <div class="byog-step" data-step="3">\
      <div class="byog-step-img"><img src="" /></div>\
      <div class="byog-step-text">\
        <p><span>Step 3:</span><span class="desktop">Complete with a card & your heartfelt words</span><span class="mobile">Write your <br />heartfelt message</span></p>\
      </div>\
    </div>\
  </div>\
</div>';

var byogNavHTML = '\
<div class="gbbNavigationItem" id="addProductsPage-step1">\
  <div class="gbbNavigationTitleContainer">\
    <p class="gbbNavigationTitle-custom"><span>Step 1:</span> Select Style</p>\
  </div>\
  <div class="byog-step1-buttons"></div>\
</div>\
<div class="gbbNavigationItem" id="addProductsPage-step2" style="display:none;">\
  <div class="gbbNavigationTitleContainer">\
    <div class="gbbNavigationTitle-custom byog-step2-titles">\
      <p class="byog-title" id="byog-title-addProductsPage1" style="display:none;"><a href="/products/personalised-baby-gift-hamper">« Back to Step 1</a><br/><span>Step 2:</span> Select Baby Boy Gifts</p>\
      <p class="byog-title" id="byog-title-addProductsPage2" style="display:none;"><a href="/products/personalised-baby-gift-hamper">« Back to Step 1</a><br/><span>Step 2:</span> Select Baby Girl Gifts</p>\
      <p class="byog-title" id="byog-title-addProductsPage3" style="display:none;"><a href="/products/personalised-baby-gift-hamper">« Back to Step 1</a><br/><span>Step 2:</span> Select Unisex Baby Gifts</p>\
    </div>\
  </div>\
</div>';

var byogAddMore = '<div class="byog-add-more">&laquo; Add More Products</div>';
var byogNextStep = '<div class="byog-next-step">Next Step &raquo;</div>';

// -------------------------------------------
// ** Wait for HTML classes
// -------------------------------------------
function waitForHtmlClasses(callback) {
  var html = document.documentElement;

  if (html.classList.contains('bundle-1') &&
      html.classList.contains('gbbBundle-HTML')) {
    callback();
    return;
  }

  var obs = new MutationObserver(function() {
    if (html.classList.contains('bundle-1') &&
        html.classList.contains('gbbBundle-HTML')) {
      obs.disconnect();
      callback();
    }
  });

  obs.observe(html, { attributes: true, attributeFilter: ['class'] });
}

// -------------------------------------------
// ** Insert header + nav
// -------------------------------------------
function tryInsertCustomHTML() {
  var headerEl = document.querySelector('.gbbPageHeader');
  if (!headerEl) return false;

  if (!headerEl.querySelector('.byog-header')) {
    headerEl.insertAdjacentHTML('afterbegin', byogHeaderHTML);
  }

  return true;
}

// -------------------------------------------
// ** Setup navigation items
// -------------------------------------------
function setupNavigationItems() {
  var container = document.querySelector('.gbbNavigationItemsContainer');
  if (!container) return;

  if (!container.querySelector('#addProductsPage-step1')) {
    container.insertAdjacentHTML('afterbegin', byogNavHTML);
  }

  var step1Buttons = container.querySelector('#addProductsPage-step1 .byog-step1-buttons');
  if (!step1Buttons) return;

  ['#addProductsPage1', '#addProductsPage2', '#addProductsPage3'].forEach(function(id) {
    var el = document.querySelector(id);
    if (el && el.parentNode !== step1Buttons) {
      step1Buttons.append(el);
    }
  });
}

// -------------------------------------------
// ** Remove products on any category
// -------------------------------------------
function injectGeneratedRemoveButtons() {

  var selectors = [
    ".gbbFooterProductsContainer .gbbFooterProductContainer",
    ".gbbFooterProductsContainer .gbbFooterProductWrapper",
    ".gbbSlotFooterProductsContainer .gbbSlotFooterProductContainer"
  ];

  var $products = $(selectors.join(","));

  $products.each(function() {
    var $p = $(this);

    if ($p.find(".gbbFooterProductRemoveButton").length > 0 ||
        $p.find(".gbbSlotFooterProductRemoveButton").length > 0 ||
        $p.find(".gbbFooterProductRemoveButtonWrapper").length > 0) {
      return;
    }

    if ($p.find(".byog-generated-remove").length > 0) {
      return;
    }

    var removeBtn = $(`
      <div class="byog-generated-remove">
        <svg fill="black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="16px" height="16px" style="background: white; border-radius: 50%; "><path d="M 13 0.1875 C 5.925781 0.1875 0.1875 5.925781 0.1875 13 C 0.1875 20.074219 5.925781 25.8125 13 25.8125 C 20.074219 25.8125 25.8125 20.074219 25.8125 13 C 25.8125 5.925781 20.074219 0.1875 13 0.1875 Z M 18.78125 17.394531 L 17.390625 18.78125 C 17.136719 19.035156 16.722656 19.035156 16.46875 18.78125 L 13 15.3125 L 9.53125 18.78125 C 9.277344 19.035156 8.863281 19.035156 8.609375 18.777344 L 7.21875 17.394531 C 6.96875 17.136719 6.96875 16.726563 7.21875 16.46875 L 10.6875 13 L 7.222656 9.535156 C 6.96875 9.277344 6.96875 8.863281 7.222656 8.609375 L 8.609375 7.222656 C 8.863281 6.964844 9.28125 6.964844 9.535156 7.222656 L 13 10.6875 L 16.46875 7.222656 C 16.722656 6.964844 17.140625 6.964844 17.390625 7.222656 L 18.78125 8.605469 C 19.035156 8.863281 19.035156 9.277344 18.78125 9.535156 L 15.3125 13 L 18.78125 16.46875 C 19.03125 16.726563 19.03125 17.136719 18.78125 17.394531 Z"></path></svg>
      </div>
    `);

    if ($p.hasClass("gbbFooterProductWrapper")) {
      var actionContainer = $p.find(".gbbFooterProductActionContainer");
      if (actionContainer.length) {
        actionContainer.append(removeBtn);
      } else {
        $p.append(removeBtn);
      }
    }
    else if ($p.closest(".gbbSlotFooterProductsContainer").length) {
      $p.append(removeBtn);
    }
    else {
      $p.append(removeBtn);
    }
  });

}

function bindUniversalRemove() {
  $(document)
    .off("click", ".byog-generated-remove")
    .on("click", ".byog-generated-remove", async function () {
      try {
        // Always start from the actual footer row
        var $row = $(this).closest(".gbbFooterProductContainer, .gbbSlotFooterProductContainer");
        if (!$row.length) return;

        // Read storage (source of truth)
        var stored =
          gbb && gbb.gbbBrowser && typeof gbb.gbbBrowser.getRelevantBoxDataFromSessionStorage === "function"
            ? gbb.gbbBrowser.getRelevantBoxDataFromSessionStorage()
            : null;

        if (!stored || !Array.isArray(stored.items) || !stored.items.length) return;

        // Determine index of the clicked row (DOM order == storage order)
        var $allRows = $(".gbbFooterProductContainer, .gbbSlotFooterProductContainer");
        var idx = $allRows.index($row);
        if (idx < 0) return;

        var item = stored.items[idx] || null;
        if (!item) return;

        // If it's an add-on, remove it by editing storage + rerender footer (no EB API calls)
        var isAddon = !!(item.properties && item.properties._addon_product);
        if (isAddon) {
          // IMPORTANT: stored (relevant box data) is NOT the full gbb-cart-1 object.
          // We must edit the full cart object to avoid wiping structure.
          var fullCart = null;
          try {
            fullCart = JSON.parse(sessionStorage.getItem("gbb-cart-1") || "null");
          } catch (e) {
            fullCart = null;
          }

          if (!fullCart || !fullCart.boxes || !fullCart.boxes.box1 || !Array.isArray(fullCart.boxes.box1.items)) return;

          // Remove by the same index assumption (DOM order == box1.items order)
          if (idx < 0 || idx >= fullCart.boxes.box1.items.length) return;

          fullCart.boxes.box1.items.splice(idx, 1);

          if (typeof byogRecomputeCartTotals === "function") {
            byogRecomputeCartTotals(fullCart);
          }

          sessionStorage.setItem("gbb-cart-1", JSON.stringify(fullCart));

          $(".gbbPageFooterHTML").replaceWith(
            gbb.f.renderCartProductsFooterHTML(null, { flow: "updateFooterWithoutAppending" })
          );

          gbb.gbbBrowser.emitCustomEvent({ eventName: "gbb-footer-rendered" });

          if (typeof byogUpdateFooterTotalFromStorage === "function") {
            byogUpdateFooterTotalFromStorage();
          }

          return;
        }

        // ----- Non-add-on (normal product): use EB remove APIs -----

        // DOM signals (used as safety checks / fallbacks)
        var domVariantId = $row.attr("variantid") || $row.attr("variantId") || "";
        var domUniqueKey = $row.attr("_uniquegbbitemkey") || $row.attr("_uniqueGbbItemKey") || "";

        // Safety check: ensure index-mapped item matches this DOM row
        if (item) {
          var itemVariantId = String(item.variant_id || item.variantId || item.id || "");
          if (domVariantId && itemVariantId && String(domVariantId) !== itemVariantId) {
            item = null;
          }
        }

        // Attempt #2: unique key match (strongest)
        if (!item && domUniqueKey) {
          item =
            stored.items.find(function (i) {
              return i && i.properties && i.properties._uniqueGbbItemKey === domUniqueKey;
            }) || null;
        }

        // Attempt #3: variant id match (last resort)
        if (!item && domVariantId) {
          item =
            stored.items.find(function (i) {
              var id = String((i && (i.variant_id || i.variantId || i.id)) || "");
              return i && id === String(domVariantId);
            }) || null;
        }

        if (!item) return;

        var isNewTemplate = gbb.$(".gbbProductsCardLayoutV2").length > 0;

        if (isNewTemplate) {
          // Prefer existing unique key if present; don't generate a new one unless needed
          var payloadUniqueKey =
            (item.properties && item.properties._uniqueGbbItemKey) ||
            gbb.utility.getUniqueIdForVariant({ productData: item });

          await gbb.utility.removeFromCart({
            variant: {
              id: item.variant_id,
              _boxProduct: item.properties && item.properties._boxProduct ? item.properties._boxProduct : "",
              _Category: item.properties && item.properties._Category ? item.properties._Category : "",
              _uniqueGbbItemKey: payloadUniqueKey
            }
          });
        } else {
          gbb.utility.removeProductFromCartFooter(item, null);
        }

        // Re-render footer
        $(".gbbPageFooterHTML").replaceWith(
          gbb.f.renderCartProductsFooterHTML(null, { flow: "updateFooterWithoutAppending" })
        );

        // Notify & sync total
        gbb.gbbBrowser.emitCustomEvent({ eventName: "gbb-footer-rendered" });

        if (typeof byogUpdateFooterTotalFromStorage === "function") {
          byogUpdateFooterTotalFromStorage();
        }
      } catch (e) {
        // console.log("[BYOG] bindUniversalRemove error:", e);
      }
    });
}

function bindNativeFooterRemoveToUpdateTotal() {
  if (window.__byogNativeRemoveBound) return;
  window.__byogNativeRemoveBound = true;

  $(document).off("click", ".gbbFooterProductRemoveButton, .gbbSlotFooterProductRemoveButton")
    .on("click", ".gbbFooterProductRemoveButton, .gbbSlotFooterProductRemoveButton", function () {
      setTimeout(function () {
        byogUpdateFooterTotalFromStorage();
      }, 150);
    });
}

// -------------------------------------------
// ** Summary Page
// -------------------------------------------


// *** Rewrite product titles from gbb-cart-1 personalization meta

var BYOG_GBB_CART_KEY = "gbb-cart-1";
var BYOG_SUMMARY_TITLE_REWRITTEN_ATTR = "data-byog-title-rewritten";

function byogReadGbbCartData() {
  try {
    var raw = sessionStorage.getItem(BYOG_GBB_CART_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function byogUpdateFooterTotalFromStorage() {
  var el = document.querySelector(".gbbFooterDiscountedTotalValue");
  if (!el) return;

  var data = byogReadGbbCartData();
  var rawTotal = data && data.total_price;
  var totalCents = Math.round(Number(rawTotal));
  if (!data || Number.isNaN(totalCents)) return;

  // Reuse existing currency formatting helpers if available
  // Your formatMoney expects amount in currency units (not cents), so divide by 100.
  try {
    if (typeof getActiveCurrencyInfo === "function" && typeof formatMoney === "function") {
      var info = getActiveCurrencyInfo();
      if (info) {
        el.textContent = formatMoney(totalCents / 100, info);
        return;
      }
    }
  } catch (e) {}

  // Fallback: simple cents -> 2 decimals
  el.textContent = (totalCents / 100).toFixed(2);
}

function byogReadGbbCartDataSafe() {
  try {
    var raw = sessionStorage.getItem("gbb-cart-1");
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function byogWriteGbbCartDataSafe(data) {
  try {
    sessionStorage.setItem("gbb-cart-1", JSON.stringify(data));
    return true;
  } catch (e) {
    return false;
  }
}

// Recompute totals from items to avoid float artifacts and partial updates
function byogRecomputeCartTotals(data) {
  if (!data || !data.boxes || !data.boxes.box1 || !Array.isArray(data.boxes.box1.items)) return;

  var items = data.boxes.box1.items;

  var total = 0;
  var count = 0;

  for (var i = 0; i < items.length; i++) {
    var it = items[i];
    if (!it) continue;

    var qty = Number(it.quantity || 1);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    var price = Number(it.price || 0); // cents
    if (!Number.isFinite(price)) price = 0;

    total += price * qty;
    count += qty;
  }

  // Keep these as numbers (EB sometimes uses floats, but integers are better here)
  data.total_price = total;
  data.item_count = count;
}

function byogRemoveAddonFromStorageByDomRow($row) {
  if (!$row || !$row.length) return false;

  var domVariantId = $row.attr("variantid") || $row.attr("variantId") || "";
  if (!domVariantId) return false;

  var data = byogReadGbbCartDataSafe();
  if (!data || !data.boxes || !data.boxes.box1 || !Array.isArray(data.boxes.box1.items)) return false;

  var items = data.boxes.box1.items;

  // Find matching add-on items in storage by variant id
  var matchIndexes = [];
  for (var i = 0; i < items.length; i++) {
    var it = items[i];
    if (!it || !it.properties) continue;

    var isAddon = !!it.properties._addon_product;
    if (!isAddon) continue;

    var itVar = String(it.variant_id || it.variantId || it.id || "");
    if (itVar === String(domVariantId)) matchIndexes.push(i);
  }

  if (!matchIndexes.length) return false;

  // If multiple exist, remove the one that best matches this DOM row by position.
  // We assume DOM rows are in the same order as items (your observation).
  // Safety: if DOM index is out of range, remove the last matching add-on.
  var $allRows = $(".gbbFooterProductContainer, .gbbSlotFooterProductContainer");
  var domIndex = $allRows.index($row);

  var removeIndex = matchIndexes[matchIndexes.length - 1];
  if (domIndex >= 0 && domIndex < items.length) {
    // Prefer exact index match if that item is indeed the add-on we want
    var candidate = items[domIndex];
    var candidateIsAddon = !!(candidate && candidate.properties && candidate.properties._addon_product);
    var candidateVar = String(candidate && (candidate.variant_id || candidate.variantId || candidate.id) || "");
    if (candidateIsAddon && candidateVar === String(domVariantId)) {
      removeIndex = domIndex;
    }
  }

  // Remove exactly one add-on line
  items.splice(removeIndex, 1);

  // Recompute totals/count to keep footer correct
  byogRecomputeCartTotals(data);

  // Persist
  if (!byogWriteGbbCartDataSafe(data)) return false;

  return true;
}

function byogCssEscape(s) {
  s = String(s || "");
  var nativeEscape = window.CSS && typeof window.CSS.escape === "function" ? window.CSS.escape : null;
  if (nativeEscape) return nativeEscape(s);
  return s.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, "\\$1");
}

function byogEscapeAttr(str) {
  return String(str == null ? "" : str).replace(/"/g, "&quot;");
}

function byogBuildFooterProductHTML(item, boxProductOverride) {
  if (!item) return "";

  var productId = item.product_id || (item.properties && item.properties.product_id) || "";
  var variantId = item.variant_id || item.variantId || item.id || "";
  var title = item.title || item.name || item.product_title || "";
  var qty = item.quantity || 1;

  var img = item.image ||
    (item.featured_image && item.featured_image.src) ||
    (item.featured_media && item.featured_media.src) ||
    "";

  // Build a markup compatible with EB footer
  var boxProduct = boxProductOverride ||
    (item.properties && item.properties._boxProduct) ||
    "";

  // Price formatting (same logic as footer total)
  var priceText = "";
  try {
    if (typeof getActiveCurrencyInfo === "function" && typeof formatMoney === "function") {
      var info = getActiveCurrencyInfo();
      if (info) priceText = formatMoney((Number(item.price || 0) / 100), info);
    }
  } catch (e) {}
  if (!priceText) priceText = (Number(item.price || 0) / 100).toFixed(2);

  // Mark add-ons so we can find/remove them later (even if EB re-renders)
  var parentKey = item.properties && item.properties._byog_parent_link ? item.properties._byog_parent_link : "";

  var extraAttrs = "";
  if (item.properties && item.properties._addon_product) {
    extraAttrs += ' data-byog-addon="1"';
  }
  if (parentKey) {
    extraAttrs += ' data-byog-parent-link="' + byogEscapeAttr(parentKey) + '"';
  }

  return (
    '<div class="gbbFooterProductContainer" productid="' + byogEscapeAttr(productId) + '" variantid="' + byogEscapeAttr(variantId) + '" _boxproduct="' + byogEscapeAttr(boxProduct) + '"' + extraAttrs + '>' +
      '<div class="gbbFooterProductImageContainer">' +
        '<img class="gbbFooterProductImage" src="' + byogEscapeAttr(img) + '">' +
      '</div>' +
      '<div class="gbbFooterProductTextContainer">' +
        '<div class="gbbFooterProductTitle">' + byogEscapeHtml(title) + '</div>' +
        '<div class="gbbFooterProductQtyPriceContainer">' +
          '<div class="gbbFooterProductPrice">' + byogEscapeHtml(priceText) + '</div>' +
          '<div class="gbbFooterProductQuantity">x' + byogEscapeHtml(qty) + '</div>' +
        '</div>' +
      '</div>' +
    '</div>'
  );
}

function byogEscapeHtml(str) {
  return String(str == null ? "" : str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function byogReadGbbCartBox1Items() {
  try {
    var raw = sessionStorage.getItem(BYOG_GBB_CART_KEY);
    if (!raw) return [];
    var data = JSON.parse(raw);
    return (data && data.boxes && data.boxes.box1 && Array.isArray(data.boxes.box1.items))
      ? data.boxes.box1.items
      : [];
  } catch (e) {
    return [];
  }
}

function byogGetPersonalizationParts(item) {
  var meta = item && item.properties && item.properties.productPersonalizationMetaData;
  if (!meta || typeof meta !== "object") return [];

  var parts = [];

  Object.keys(meta).forEach(function (key) {
    var entry = meta[key];
    if (!entry) return;

    // Only show if it has a value
    var value = entry.value;
    if (value == null) return;

    var valueStr = String(value).trim();
    if (!valueStr) return;

    // Optional: respect "showValueOnSummaryPage" if present
    if (entry.showValueOnSummaryPage === false) return;

    // Use the KEY (e.g. "Baby Name"), not fieldLabel
    parts.push(byogEscapeHtml(key) + ": " + byogEscapeHtml(valueStr));
  });

  return parts;
}

function rewriteSummaryTitlesFromPersonalization() {
  // Title elements in Summary (one per item)
  var titleEls = document.querySelectorAll(
    ".gbbSummaryPageBundleProductsMainContainer .gbbSummaryPageProductListItem .gbbSummaryPageProductListItemName"
  );
  if (!titleEls.length) return;

  var items = byogReadGbbCartBox1Items();
  if (!items.length) return;

  for (var i = 0; i < titleEls.length; i++) {
    var el = titleEls[i];

    // Avoid rewriting same DOM node twice
    if (el.getAttribute(BYOG_SUMMARY_TITLE_REWRITTEN_ATTR) === "1") continue;

    var item = items[i];
    if (!item) continue;

    var parts = byogGetPersonalizationParts(item);

    // Only rewrite for products that actually have personalization values
    if (!parts.length) continue;

    // Use items[].name as requested; fallback to items[].title if name missing
    var baseTitle = item.name || item.title || (el.textContent || "").trim();

    // Format:
    // items[].name <br/> Key: value | Key2: value2 ...
    var html =
      byogEscapeHtml(baseTitle) +
      "<br />" +
      parts.join(" | ");

    el.innerHTML = html;
    el.setAttribute(BYOG_SUMMARY_TITLE_REWRITTEN_ATTR, "1");
  }
}

function ensureSummaryTitleRewriteObserver() {
  // Attach once
  if (window.byogSummaryTitleRewriteObserver) return;

  var root = document.querySelector(".gbbSummaryPageBundleProductsMainContainer");
  if (!root) return;

  window.byogSummaryTitleRewriteObserver = new MutationObserver(function () {
    rewriteSummaryTitlesFromPersonalization();
  });

  window.byogSummaryTitleRewriteObserver.observe(root, { childList: true, subtree: true });
}
// *** END - Rewrite product titles from gbb-cart-1 personalization meta

function bindSummaryEditButton() {
  var $summary = $(".gbbSummaryPageWrapper");
  if (!$summary.length) return;

  $summary.find(".gbbSummaryPageBundleEditButton").each(function () {
    var $btn = $(this);
    if ($btn.find(".byog-edit-overlay").length) return;

    var overlay = $('<div class="byog-edit-overlay"></div>');
    $btn.append(overlay);

    overlay.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // DO NOT set step here
      // DO NOT touch UI here

      $btn[0].click(); // let GBB navigate
    });
  });
}

function observeSummary() {
  // This observer exists ONLY to:
  // - wait for GBB async summary render
  // - apply custom title once
  // - prepare edit flow (style switch)
  // It does NOT handle refresh recovery.
  var observer = new MutationObserver(function () {

    var $summary = $('.gbbSummaryPageWrapper');
    if (!$summary.length) return;

    var box = getBYOGBox();
    if (!box || !box.style) return;

    // 1. Apply custom title (AFTER GBB render)
    updateSummaryBoxTitles();

     // Rewrite per-product titles from gbb-cart-1 personalization meta
    rewriteSummaryTitlesFromPersonalization();
    ensureSummaryTitleRewriteObserver();

    // (optional but recommended) keep your edit overlay working in Summary
    bindSummaryEditButton();

    // 2. Prepare edit flow (DO NOT change UI now)
    byogSelectedStyle = box.style;
    window.byogShouldAutoSwitchStyle = true;

    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// -------------------------------------------
// ** UI Update by step
// -------------------------------------------
function updateStep2Title() {
  if (!byogSelectedStyle) return;

  $('.byog-title').hide();
  $('#byog-title-' + byogSelectedStyle).show();
}

function getValidProducts() {
  return $('.gbbFooterProductsContainer .gbbFooterProductContainer')
    .filter(function() {
      return $(this).attr('_boxproduct') !== 'addProductsPage4';
    });
}

function updateBYOGUI() {

  // Reset all
  $('.byog-next-step').hide();
  $('.byog-add-more').hide();
  $('.gbbFooterNextButton').hide();
  $('#addProductsPage-step1, #addProductsPage-step2').hide();
  $('#addProductsPage4').hide();
  $('.gbbAddProductsPageHTML').hide();

  // STEP 1
  if (byogCurrentStep === 1) {
    $('#addProductsPage-step1').show();
    $('.gbbMultipleCategoriesContainerHTMLForTabUI').hide();
    $('.gbbAddProductsPageFooterHTML').hide();
    return;
  }

  // STEP 2
  if (byogCurrentStep === 2) {

    $('#addProductsPage-step2').show();
    $('.gbbMultipleCategoriesContainerHTMLForTabUI').show();
    $('.gbbAddProductsPageFooterHTML').show();

    var validProducts = getValidProducts();
    if (validProducts.length > 0) $('.byog-next-step').show();

    return;
  }

  // STEP 3
  if (byogCurrentStep === 3) {
    $('#addProductsPage4').show();
    $('.gbbAddProductsPageHTML').show();
    $('.gbbFooterNextButton').show();
    $('.byog-add-more').show();

    var validProducts = getValidProducts();

    if (validProducts.length === 0) $('.gbbFooterNextButton').hide();

    ensureStep3FilterObserver();
    filterStep3Products();
  }
}

function getStyleLabel(style) {
  switch (style) {
    case 'addProductsPage1': return 'Baby Boy Gift Box';
    case 'addProductsPage2': return 'Baby Girl Gift Box';
    case 'addProductsPage3': return 'Unisex Baby Gift Box';
    default: return 'Baby Gift Box';
  }
}

function updateSummaryBoxTitles() {
  var box = getBYOGBox();
  if (!box.style) return;

  var title = getStyleLabel(box.style);
  if (box.babyName) {
    title += ' - ' + box.babyName;
  }

  $('.gbbSummaryPageBundleTitle').text(title);
}

// -------------------------------------------
// ** Save & Autofill Baby Name
// -------------------------------------------

function bindBabyNameAutofillOnModalOpen() {
  var observer = new MutationObserver(function () {

    var $input = $('.gbbProductVariantModalMainContainer:visible')
      .find('input.gbbProductFormText[fieldkey="Baby Name"]')
      .first();

    if (!$input.length) return;

    prefillBabyName($input);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function prefillBabyName($input) {
  var saved = sessionStorage.getItem(BYOG_BABY_NAME_KEY);
  if (!saved) return;
  if ($input.val()) return;

  var input = $input[0];
  input.focus();

  // Clear first (important for state)
  input.value = '';

  saved.split('').forEach(function (char) {

    // keydown
    input.dispatchEvent(new KeyboardEvent('keydown', {
      key: char,
      bubbles: true
    }));

    // keypress
    input.dispatchEvent(new KeyboardEvent('keypress', {
      key: char,
      bubbles: true
    }));

    // update value
    input.value += char;

    // input
    input.dispatchEvent(new Event('input', { bubbles: true }));

    // keyup
    input.dispatchEvent(new KeyboardEvent('keyup', {
      key: char,
      bubbles: true
    }));
  });
}

$(document)
  .off('mousedown.byogSaveBabyName')
  .on('mousedown.byogSaveBabyName', '.gbbProductVariantAddButton', function () {

    var $modal = $('.gbbProductVariantModalMainContainer:visible').last();
    if (!$modal.length) return;

    var $input = $modal.find('input.gbbProductFormText[fieldkey="Baby Name"]');
    if (!$input.length) return;

    var value = $input.val().trim();
    if (!value) return;

    // Save baby name into the single BYOG box
    saveBoxBabyName(value);
    sessionStorage.setItem(BYOG_BABY_NAME_KEY, value);
});

// -------------------------------------------
// ** Event Handlers
// -------------------------------------------
function bindBYOGEvents() {
  if (byogEventsBound) return;
  byogEventsBound = true;

  // -------------------------------------------
  // Step 1 → Step 2 (select style)
  // -------------------------------------------
  ['#addProductsPage1', '#addProductsPage2', '#addProductsPage3'].forEach(function (id) {
    $(document).on('click', id, function () {

      var style = id.replace('#', '');

      byogSelectedStyle = style;
      byogCurrentStep = 2;

      // Save style into the single BYOG box
      saveBoxStyle(style);

      updateBYOGUI();
      updateStep2Title();
    });
  });

  // -------------------------------------------
  // Step 2 → Step 3
  // -------------------------------------------
  $(document).on('click', '.byog-next-step', function () {
    $('#addProductsPage4').trigger('click');
    byogCurrentStep = 3;
    updateBYOGUI();

    ensureStep3FilterObserver();
    filterStep3Products();
  });

  // -------------------------------------------
  // Step 3 → Step 2 (Add more products)
  // -------------------------------------------
  $(document).on('click', '.byog-add-more', function () {
    if (!byogSelectedStyle) return;

    $('#' + byogSelectedStyle).trigger('click');
    byogCurrentStep = 2;
    updateBYOGUI();
  });
}

// -------------------------------------------
// ** BYOG state helpers
// -------------------------------------------

function resetBYOGState() {
  sessionStorage.removeItem(BYOG_BOXES_KEY);
  sessionStorage.removeItem(BYOG_BABY_NAME_KEY);

  byogSelectedStyle = null;
  byogCurrentStep = 1;
}

// Checkout
document.addEventListener('gbb-checkout-button-click', function () {
  resetBYOGState();
});

function getBYOGBox() {
  try {
    return JSON.parse(sessionStorage.getItem(BYOG_BOXES_KEY)) || {};
  } catch (e) {
    return {};
  }
}

function saveBYOGBox(data) {
  sessionStorage.setItem(BYOG_BOXES_KEY, JSON.stringify(data));
}

function saveBoxStyle(style) {
  if (!style) return;

  var box = getBYOGBox();
  box.style = style;
  saveBYOGBox(box);
}

function saveBoxBabyName(babyName) {
  if (!babyName) return;

  var box = getBYOGBox();
  box.babyName = babyName;
  saveBYOGBox(box);
}

// -------------------------------------------
// Step 3 only: Hide products by style (boy/girl keywords)
// -------------------------------------------
var BYOG_STEP3_HIDDEN_CLASS = "byog-hidden-by-style";
var byogStep3Observer = null;

function isStep3Active() {
  if (byogCurrentStep !== 3) return false;

  var step3El = document.querySelector("#addProductsPage4");
  if (!step3El) return false;

  // Visible check (works even if parent is hidden)
  return !!(step3El.offsetWidth || step3El.offsetHeight || step3El.getClientRects().length);
}

function filterStep3Products() {
  if (!isStep3Active()) return;

  var container = document.querySelector(".gbbProductsItemsContainer");
  if (!container) return;

  var items = container.querySelectorAll(".gbbProductItem");
  if (!items.length) return;

  items.forEach(function (item) {
    var titleEl = item.querySelector(".gbbProductTitleOnly");
    var title = (titleEl ? titleEl.textContent : "").toLowerCase();

    // Reset first
    item.classList.remove(BYOG_STEP3_HIDDEN_CLASS);
    item.style.display = "";

    // Boy selected → hide girl products
    if (byogSelectedStyle === "addProductsPage1" && title.includes("girl")) {
      item.classList.add(BYOG_STEP3_HIDDEN_CLASS);
      item.style.display = "none";
      return;
    }

    // Girl selected → hide boy products
    if (byogSelectedStyle === "addProductsPage2" && title.includes("boy")) {
      item.classList.add(BYOG_STEP3_HIDDEN_CLASS);
      item.style.display = "none";
      return;
    }

    // Unisex → show all
  });
}

function ensureStep3FilterObserver() {
  // Only attach observer once, but it should only run filtering when Step 3 is active
  if (byogStep3Observer) return;

  var container = document.querySelector(".gbbProductsItemsContainer");
  if (!container) return;

  byogStep3Observer = new MutationObserver(function () {
    // Re-apply only if Step 3 is currently active
    if (!isStep3Active()) return;
    filterStep3Products();
  });

  byogStep3Observer.observe(container, { childList: true, subtree: true });
}

// -------------------------------------------
// ** BYOG setup wrapper (runs on AJAX updates)
// -------------------------------------------
function setupBYOG() {
  if (!tryInsertCustomHTML()) return;

  setupNavigationItems();

  if (!$('.gbbFooterButtonsWrapper .byog-next-step').length)
    $('.gbbFooterButtonsWrapper').append(byogNextStep);

  if (!$('.gbbFooterButtonsWrapper .byog-add-more').length)
    $('.gbbFooterButtonsWrapper').prepend(byogAddMore);

  injectGeneratedRemoveButtons();
  bindUniversalRemove();
  bindOptimisticFooterUpdatesAfterModalAdd();
  bindNativeFooterRemoveToUpdateTotal();
  bindBYOGEvents();

  // Autofill observer (bind once)
  if (!window.byogBabyNameObserverBound) {
    bindBabyNameAutofillOnModalOpen();
    window.byogBabyNameObserverBound = true;
  }

  // Auto switch style (Edit flow)
  if (window.byogShouldAutoSwitchStyle && byogSelectedStyle) {
    window.byogShouldAutoSwitchStyle = false;

    setTimeout(function () {
      $("#" + byogSelectedStyle).trigger("click");

      byogCurrentStep = 2;
      updateBYOGUI();
      updateStep2Title();
    }, 50);
  }

  updateBYOGUI();
  updateStep2Title();
  observeSummary();
}

// -------------------------------------------
// FOOTER STUFF
// -------------------------------------------
function byogGetFooterProductsContainer() {
  return document.querySelector(".gbbFooterProductsContainer") ||
         document.querySelector(".gbbSlotFooterProductsContainer") ||
         null;
}

function byogFindFooterNodeForParent(parentItem) {
  if (!parentItem) return null;

  var parentKey = parentItem.properties && parentItem.properties._uniqueGbbItemKey ? parentItem.properties._uniqueGbbItemKey : "";
  var parentVariantId = String(parentItem.variant_id || parentItem.variantId || parentItem.id || "");

  // Best: match by _uniqueGbbItemKey if EB outputs it as attribute
  if (parentKey) {
    var byKey = document.querySelector('.gbbFooterProductContainer[_uniquegbbitemkey="' + byogCssEscape(parentKey) + '"]');
    if (byKey) return byKey;
  }

  // Fallback: last occurrence of variantid (handles duplicates better)
  var nodes = document.querySelectorAll('.gbbFooterProductContainer[variantid="' + byogCssEscape(parentVariantId) + '"]');
  if (nodes && nodes.length) return nodes[nodes.length - 1];

  return null;
}

function byogOptimisticInsertLatestAddonUnderParent() {
  var data = byogReadGbbCartData();
  if (!data || !data.boxes || !data.boxes.box1 || !Array.isArray(data.boxes.box1.items)) return;

  var items = data.boxes.box1.items;
  if (items.length < 2) return;

  // Find the newest addon in storage (last addon item)
  var addon = null;
  for (var i = items.length - 1; i >= 0; i--) {
    var it = items[i];
    if (it && it.properties && it.properties._addon_product) { addon = it; break; }
  }
  if (!addon) return;

  var parentLink = addon.properties && addon.properties._byog_parent_link ? addon.properties._byog_parent_link : "";
  if (!parentLink) return;

  // Find parent item in storage by _uniqueGbbItemKey
  var parent = null;
  for (var j = items.length - 1; j >= 0; j--) {
    var pit = items[j];
    if (!pit || !pit.properties) continue;
    if (pit.properties._uniqueGbbItemKey === parentLink) { parent = pit; break; }
  }
  if (!parent) return;

  // If addon is already in DOM for this parent, do nothing
  var existing = document.querySelector('.gbbFooterProductContainer[data-byog-addon="1"][data-byog-parent-link="' + byogCssEscape(parentLink) + '"][variantid="' + byogCssEscape(String(addon.variant_id || addon.variantId || addon.id || "")) + '"]');
  if (existing) return;

  var parentNode = byogFindFooterNodeForParent(parent);
  var container = byogGetFooterProductsContainer();
  if (!container) return;

  var style = (getBYOGBox && getBYOGBox().style) ? getBYOGBox().style : "addProductsPage1";
  var html = byogBuildFooterProductHTML(addon, style);
  if (!html) return;

  if (parentNode && parentNode.parentNode) {
    parentNode.insertAdjacentHTML("afterend", html);
  } else {
    // Fallback: append to end
    container.insertAdjacentHTML("beforeend", html);
  }

  // Ensure remove buttons exist on the newly inserted node
  injectGeneratedRemoveButtons();

  // Update footer total immediately
  byogUpdateFooterTotalFromStorage();
}

function bindOptimisticFooterUpdatesAfterModalAdd() {
  // Prevent multiple bindings
  if (window.__byogOptimisticFooterBound) return;
  window.__byogOptimisticFooterBound = true;

  function byogRetryOptimisticInsert(triesLeft) {
    triesLeft = typeof triesLeft === "number" ? triesLeft : 8; // ~1 second total

    var before = document.querySelectorAll(
      '.gbbFooterProductContainer[data-byog-addon="1"]'
    ).length;

    // Try to insert addon from session storage
    if (typeof byogOptimisticInsertLatestAddonUnderParent === "function") {
      byogOptimisticInsertLatestAddonUnderParent();
    }

    var after = document.querySelectorAll(
      '.gbbFooterProductContainer[data-byog-addon="1"]'
    ).length;

    // If addon appeared, stop retrying
    if (after > before) return;

    // Otherwise retry a few times (storage may not be ready yet)
    if (triesLeft > 0) {
      setTimeout(function () {
        byogRetryOptimisticInsert(triesLeft - 1);
      }, 120);
    }
  }

  // Listen to modal "Add" button
  document.addEventListener(
    "click",
    function (e) {
      var btn =
        e.target && e.target.closest
          ? e.target.closest(".gbbProductVariantAddButton")
          : null;
      if (!btn) return;

      // Give EB time to update session storage
      setTimeout(function () {
        byogRetryOptimisticInsert(8);
      }, 120);
    },
    true
  );
}

// -------------------------------------------
// MASTER FLOW
// -------------------------------------------
document.addEventListener('DOMContentLoaded', function() {

  waitForHtmlClasses(function() {

    setupBYOG();

    setTimeout(scheduleSetupBYOG, 400);

    var container = document.querySelector('#gbbBody') ||
                    document.querySelector('.gbbMainContainer') ||
                    document.body;
    var __byogSetupTimer = null;

    function scheduleSetupBYOG() {
      if (__byogSetupTimer) clearTimeout(__byogSetupTimer);
      __byogSetupTimer = setTimeout(function () {
        __byogSetupTimer = null;
        setupBYOG();
      }, 60);
    }

    new MutationObserver(function () {
      scheduleSetupBYOG();
    }).observe(container, { childList: true, subtree: true });

  });

});

// END -- BYOG CUSTOM CODE

// --------------------------------------------------------------------
// START -- BYOG -- SOFT TOYS PERSONALISATION FILTER
(function () {
  var CATEGORY_TITLE = "Soft Toys";

  // Tag -> allowed radio values
  var TAG_TO_VALUES = {
    earp: ["One Ear"],
    earsp: ["Both Ears"],
    jumperp: ["Jumper"]
  };

  var RADIO_FIELDKEY = "Add embroidery to";

  var FIELDKEY_EAR_1 = "Embroidery on Ear";
  var FIELDKEY_EAR_2 = "Embroidery on other Ear";
  var FIELDKEY_JUMPER = "Embroidery on Jumper";
  var FIELDKEY_JUMPER_2 = "Jumper Colour";
  var FIELDKEY_FONT = "Embroidery Font";
  var FIELDKEY_THREAD_COLOUR = "Thread Colour";

  var INDEX_KEY = "byog_soft_toys_tag_index_v1"; // sessionStorage key
  var indexBuilt = false;

  function normalize(s) {
    return String(s || "").trim().toLowerCase();
  }

  function getSettings() {
    return window.tmpCartSettings2 || window.tmpCartSettings || null;
  }

  function tryLoadIndexFromSession() {
    try {
      var raw = sessionStorage.getItem(INDEX_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function saveIndexToSession(indexObj) {
    try {
      sessionStorage.setItem(INDEX_KEY, JSON.stringify(indexObj));
    } catch (e) {}
  }

  function collectCategories(settings) {
    var out = [];

    function walk(node) {
      if (!node || typeof node !== "object") return;

      if (node.categoryId && node.title && Array.isArray(node.products)) {
        out.push(node);
      }

      for (var k in node) {
        if (!Object.prototype.hasOwnProperty.call(node, k)) continue;
        var v = node[k];
        if (!v || typeof v !== "object") continue;
        if (Array.isArray(v)) {
          for (var i = 0; i < v.length; i++) walk(v[i]);
        } else {
          walk(v);
        }
      }
    }

    walk(settings);
    return out;
  }

  function buildIndexOnce() {
    if (indexBuilt) return;

    // 1) Try sessionStorage first
    var fromSession = tryLoadIndexFromSession();
    if (fromSession && fromSession.byProductId) {
      window.__byogSoftToysIndex = fromSession;
      indexBuilt = true;
      return;
    }

    // 2) Build from settings
    var settings = getSettings();
    if (!settings) return;

    var categories = collectCategories(settings);
    var wanted = normalize(CATEGORY_TITLE);

    var byProductId = {}; // productId -> { tags: {tag:true}, allowedValues: {value:true} }

    for (var c = 0; c < categories.length; c++) {
      var cat = categories[c];
      if (normalize(cat.title) !== wanted) continue;

      for (var p = 0; p < cat.products.length; p++) {
        var prod = cat.products[p];
        if (!prod || !prod.productId) continue;

        // Collect tags first
        var tags = {};
        if (Array.isArray(prod.tags)) {
          for (var t = 0; t < prod.tags.length; t++) {
            var tag = normalize(prod.tags[t]);
            if (tag) tags[tag] = true;
          }
        }

        // Keep ONLY products that have at least one of the 3 tags
        var isRelevant = !!(tags.earp || tags.earsp || tags.jumperp);
        if (!isRelevant) continue;

        var pid = String(prod.productId);

        if (!byProductId[pid]) byProductId[pid] = { tags: {}, allowedValues: {} };

        // Merge tags + allowed values
        for (var tagKey in tags) {
          if (!Object.prototype.hasOwnProperty.call(tags, tagKey)) continue;

          byProductId[pid].tags[tagKey] = true;

          if (TAG_TO_VALUES[tagKey]) {
            for (var v = 0; v < TAG_TO_VALUES[tagKey].length; v++) {
              byProductId[pid].allowedValues[TAG_TO_VALUES[tagKey][v]] = true;
            }
          }
        }
      }
    }

    var indexObj = { categoryTitle: CATEGORY_TITLE, byProductId: byProductId };

    window.__byogSoftToysIndex = indexObj;
    saveIndexToSession(indexObj);
    indexBuilt = true;
  }

  function getModalContainer() {
    return document.querySelector(
      ".gbbProductVariantModalContainer.gbbProductVariantModalContainerWithPersonalization"
    );
  }

  function getModalProductId(modalEl) {
    if (!modalEl) return null;
    return modalEl.getAttribute("productid") || modalEl.getAttribute("productId") || null;
  }

  function findRadioInputs(modalEl) {
    return modalEl.querySelectorAll(
      '.gbbProductFormRadioListItems input.personalizationRadioInput[type="radio"]'
    );
  }

  function isTargetRadio(input) {
    return normalize(input.getAttribute("fieldkey")) === normalize(RADIO_FIELDKEY) ||
           normalize(input.name) === normalize(RADIO_FIELDKEY);
  }

  function setRadioItemVisible(input, visible) {
    var item = input.closest(".gbbProductFormRadioListItem");
    if (!item) return;
    item.style.display = visible ? "" : "none";
  }

  function setTextContainerVisible(modalEl, fieldKey, visible) {
    var els = modalEl.querySelectorAll(
      '.gbbProductFormTextContainer[fieldkey="' + fieldKey + '"], ' +
      '.gbbProductFormImageSelectorContainer[fieldkey="' + fieldKey + '"]'
    );

    if (!els.length) return;

    els.forEach(function(el) {
      el.style.display = visible ? "" : "none";
    });
  }

  function hideAllEmbroideryInputs(modalEl) {
    setTextContainerVisible(modalEl, FIELDKEY_EAR_1, false);
    setTextContainerVisible(modalEl, FIELDKEY_EAR_2, false);
    setTextContainerVisible(modalEl, FIELDKEY_JUMPER, false);
    setTextContainerVisible(modalEl, FIELDKEY_JUMPER_2, false);
  }

  function setEmbroideryOptionsVisible(modalEl, visible) {
    var els = modalEl.querySelectorAll(
      '.gbbProductFormImageSelectorContainer[fieldkey="' + FIELDKEY_FONT + '"], ' +
      '.gbbProductFormRadioContainer[fieldkey="' + FIELDKEY_THREAD_COLOUR + '"]'
    );

    els.forEach(function (el) {
      el.style.display = visible ? "" : "none";
    });
  }

  // -----------------------------
  // --- START Currency helpers
  // -----------------------------

  function getActiveCurrencyCode() {
    try {
      return (window.Shopify && Shopify.currency && Shopify.currency.active) ? String(Shopify.currency.active) : "";
    } catch (e) {
      return "";
    }
  }

  function getCurrencyRate() {
    try {
      var r = window.Shopify && Shopify.currency && Shopify.currency.rate ? Shopify.currency.rate : 1;
      var n = parseFloat(r);
      return isNaN(n) ? 1 : n;
    } catch (e) {
      return 1;
    }
  }

  function getMultipleCurrenciesInfoFromSettings() {
    var settings = getSettings();

    if (settings && settings.userData && settings.userData.multipleCurrenciesInfo) {
      return settings.userData.multipleCurrenciesInfo;
    }

    // Fallbacks (just in case)
    if (settings && settings.multipleCurrenciesInfo) return settings.multipleCurrenciesInfo;
    if (window.tmpCartSettings2 && window.tmpCartSettings2.userData && window.tmpCartSettings2.userData.multipleCurrenciesInfo) {
      return window.tmpCartSettings2.userData.multipleCurrenciesInfo;
    }

    return null;
  }

  function getActiveCurrencyInfo() {
    try {
      var code = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (!code) return null;

      var dict = getMultipleCurrenciesInfoFromSettings(); // ✅ use the correct helper
      if (!dict || !dict[code]) return null;

      return dict[code];
    } catch (e) {
      return null;
    }
  }


  function formatAmount(amount, info) {
    // amount is number in active currency
    var digits = info.decimalDigits;
    var fixed = Number(amount).toFixed(digits);

    var parts = fixed.split(".");
    var intPart = parts[0];
    var decPart = parts[1] || "";

    // Add thousands separators
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, info.thousandsSeparator);

    if (digits > 0) {
      return intPart + info.decimalSeparator + decPart;
    }
    return intPart;
  }

  function formatMoney(amount, info) {
    var formatted = formatAmount(amount, info);
    //var space = info.spaceBetweenAmountAndSymbol ? " " : "";

    //if (info.symbolOnLeft) {
      return info.symbol + formatted;
    //}
    //return formatted + space + info.symbol;
  }

  function setRadioLabelHtml(modalEl, value, html) {
    var input = modalEl.querySelector(
      '.gbbProductFormRadioListItems input.personalizationRadioInput[type="radio"][fieldkey="' + RADIO_FIELDKEY + '"][value="' + value + '"]'
    );
    if (!input) return;

    var label = input.closest("label");
    if (!label) return;

    var span =
      label.querySelector('span.personalizationRadioLabel[fieldkey="' + RADIO_FIELDKEY + '"]') ||
      label.querySelector("span.personalizationRadioLabel") ||
      label.querySelector("span");

    if (!span) return;

    span.innerHTML = html;
  }

  function updateEmbroideryPriceLabels(modalEl) {

    if (!modalEl) return;

    var info = getActiveCurrencyInfo();
    if (!info) return;

    var rate = getCurrencyRate();

    // Base prices in shop currency (as per your example)
    var oneEar = 9.90 * rate;
    var bothEars = 18.80 * rate;
    var jumper = 25.00 * rate;

    setRadioLabelHtml(
      modalEl,
      "One Ear",
      'One Ear <span class="personalisation-fee">(' + '+ ' + formatMoney(oneEar, info) + ')</span>'
    );
    setRadioLabelHtml(
      modalEl,
      "Both Ears",
      'Both Ears <span class="personalisation-fee">(' + '+ ' + formatMoney(bothEars, info) + ')</span>'
    );
    setRadioLabelHtml(
      modalEl,
      "Jumper",
      'Jumper <span class="personalisation-fee">(' + '+ ' + formatMoney(jumper, info) + ')</span>'
    );
  }
  function updateEmbroideryPriceLabelsAfterRender(modalEl) {
    setTimeout(function () {
      requestAnimationFrame(function () {
        updateEmbroideryPriceLabels(modalEl);
      });
    }, 0);
  }

  // -----------------------------
  // --- END Currency helpers
  // -----------------------------

  function getSavedBabyName() {
    try {
      return (sessionStorage.getItem("byog_baby_name") || "").trim();
    } catch (e) {
      return "";
    }
  }

  function typeValueLikeUser(input, value) {
    if (!input || !value) return;

    // Do not overwrite user input
    if (input.value && input.value.trim() !== "") return;

    try {
      input.focus();
    } catch (e) {}

    // Clear first
    input.value = "";

    value.split("").forEach(function (char) {
      input.dispatchEvent(new KeyboardEvent("keydown", { key: char, bubbles: true }));
      input.dispatchEvent(new KeyboardEvent("keypress", { key: char, bubbles: true }));

      input.value += char;
      input.dispatchEvent(new Event("input", { bubbles: true }));

      input.dispatchEvent(new KeyboardEvent("keyup", { key: char, bubbles: true }));
    });

    // Extra safety for listeners that rely on change
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function populateFirstVisibleEmbroideryInput(modalEl, fieldKey) {
    var babyName = getSavedBabyName();
    if (!babyName) return;

    var container = modalEl.querySelector('.gbbProductFormTextContainer[fieldkey="' + fieldKey + '"]');
    if (!container) return;

    // Only if container is actually visible
    if (container.style.display === "none") return;

    var input = container.querySelector("input, textarea");
    if (!input) return;

    typeValueLikeUser(input, babyName);
  }

  function updateEmbroideryInputsBySelection(modalEl) {
    // If nothing selected, keep all hidden (because options are optional)
    hideAllEmbroideryInputs(modalEl);
    setEmbroideryOptionsVisible(modalEl, false);

    var radios = findRadioInputs(modalEl);
    var selectedValue = null;
    var selectedIsVisible = false;

    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (!isTargetRadio(r)) continue;
      if (!r.checked) continue;

      selectedValue = String(r.value || "").trim();

      var item = r.closest(".gbbProductFormRadioListItem");
      selectedIsVisible = !!item && item.style.display !== "none";
      break;
    }

    if (!selectedValue || !selectedIsVisible) return;

    setEmbroideryOptionsVisible(modalEl, true);

    if (selectedValue === "One Ear") {
      setTextContainerVisible(modalEl, FIELDKEY_EAR_1, true);

      // Populate only the first visible field
      populateFirstVisibleEmbroideryInput(modalEl, FIELDKEY_EAR_1);

    } else if (selectedValue === "Both Ears") {
      setTextContainerVisible(modalEl, FIELDKEY_EAR_1, true);
      setTextContainerVisible(modalEl, FIELDKEY_EAR_2, true);

      // Populate ONLY the first field (Ear 1)
      populateFirstVisibleEmbroideryInput(modalEl, FIELDKEY_EAR_1);

    } else if (selectedValue === "Jumper") {
      setTextContainerVisible(modalEl, FIELDKEY_JUMPER, true);
      setTextContainerVisible(modalEl, FIELDKEY_JUMPER_2, true);

      // Populate ONLY the first field
      populateFirstVisibleEmbroideryInput(modalEl, FIELDKEY_JUMPER);
    }
  }

  function bindRadioChangeOnce(modalEl) {
    if (!modalEl || modalEl.__byogEmbroideryBound) return;
    modalEl.__byogEmbroideryBound = true;

    modalEl.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (!t.matches('input.personalizationRadioInput[type="radio"]')) return;
      if (!isTargetRadio(t)) return;

      updateEmbroideryInputsBySelection(modalEl);
      updateEmbroideryPriceLabelsAfterRender(modalEl);
    });
  }

  function applyFilterInModal() {
    buildIndexOnce();

    var idx = window.__byogSoftToysIndex;
    if (!idx || !idx.byProductId) return;

    var modalEl = getModalContainer();
    if (!modalEl) return;

    var pid = getModalProductId(modalEl);
    if (!pid) return;

    var entry = idx.byProductId[String(pid)];

    // If not Soft Toys (per index), do nothing
    if (!entry) return;

    // If it has none of our tags, keep radios as-is (safer)
    var hasRule = !!(entry.tags.earp || entry.tags.earsp || entry.tags.jumperp);

    var radios = findRadioInputs(modalEl);
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (!isTargetRadio(r)) continue;

      if (!hasRule) {
        setRadioItemVisible(r, true);
      } else {
        var val = String(r.value || "").trim();
        setRadioItemVisible(r, !!entry.allowedValues[val]);
      }
    }

    updateEmbroideryPriceLabelsAfterRender(modalEl);

    bindRadioChangeOnce(modalEl);
    updateEmbroideryInputsBySelection(modalEl);
  }

  // Build index once when BYOG is ready (you already have waitForHtmlClasses)
  if (typeof waitForHtmlClasses === "function") {
    waitForHtmlClasses(function () {
      buildIndexOnce();
    });
  }

  // Apply filter whenever modal opens (event exists in your file already)
  document.addEventListener("gbb-variants-modal-open", function () {
    setTimeout(applyFilterInModal, 0);
  });
})();
// END -- BYOG -- SOFT TOYS PERSONALISATION FILTER

// --------------------------------------------------------------------
// START -- BYOG -- AUTO-ADD EMBROIDERY ADD-ON PRODUCTS (Soft Toys)
// Adds an add-on line in sessionStorage gbb-cart-1 right after the parent item
// is added from the product modal.
// --------------------------------------------------------------------
// BYOG (EB) - Soft Toys: add paid embroidery add-ons as proper EB items
(function () {
  var KEY = "gbb-cart-1";
  var BOX = "box1";
  var CATEGORY_NAME = "Soft Toys";
  var RADIO_FIELDKEY = "Add embroidery to";

  // Prices in cents
  var ADDONS = {
    "One Ear":  { product_id: 9242089292013, variant_id: 49232559964397, price: 990  },
    "Both Ears":{ product_id: 9243871052013, variant_id: 49245567320301, price: 1880 },
    "Jumper":   { product_id: 9242089357549, variant_id: 49232560619757, price: 2500 }
  };

  // Cache variant JSON to avoid repeated requests
  var variantCache = {};

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || ""); } catch (e) { return null; }
  }
  function write(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); return true; } catch (e) { return false; }
  }
  function normalize(s) {
    return String(s || "").trim();
  }

  function getChoice(modalEl) {
    if (!modalEl) return "";
    var radios = modalEl.querySelectorAll(
      'input.personalizationRadioInput[type="radio"][fieldkey="' + RADIO_FIELDKEY + '"]'
    );
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return normalize(radios[i].value);
    }
    return "";
  }

  function findLastSoftToyParent(box) {
    var items = box && box.items;
    if (!Array.isArray(items) || !items.length) return null;

    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i];
      if (!it) continue;
      var p = it.properties || {};
      if (p._addon_product) continue;
      if (p._CategoryName !== CATEGORY_NAME) continue;
      if (!p._uniqueGbbItemKey) continue;
      return { item: it, index: i };
    }
    return null;
  }

  function hasAddonForParent(items, parentLink, addonVariantId) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.properties) continue;
      if (!it.properties._addon_product) continue;
      if (String(it.variant_id) !== String(addonVariantId)) continue;
      if (String(it.properties._byog_parent_link || "") === String(parentLink)) return true;
    }
    return false;
  }

  function fetchVariantJson(variantId) {
    var key = String(variantId);
    if (variantCache[key]) return Promise.resolve(variantCache[key]);

    return fetch("/variants/" + key + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        variantCache[key] = j;
        return j;
      })
      .catch(function () { return null; });
  }

  function recalcTotals(data) {
    if (!data || !data.boxes) return;

    var rootTotal = 0;
    var rootCount = 0;

    Object.keys(data.boxes).forEach(function (bk) {
      var b = data.boxes[bk];
      if (!b || !Array.isArray(b.items)) return;

      var boxTotal = 0;
      var boxCount = 0;

      for (var i = 0; i < b.items.length; i++) {
        var it = b.items[i];
        if (!it) continue;
        var q = Number(it.quantity || 0);
        var pr = Number(it.price || 0);
        boxTotal += q * pr;
        boxCount += q;
      }

      b.total_price = boxTotal;
      b.item_count = boxCount;

      rootTotal += boxTotal;
      rootCount += boxCount;
    });

    data.total_price = rootTotal;
    data.item_count = rootCount;
  }

  function emitRefresh() {
    if (window.gbb && window.gbb.gbbBrowser && typeof window.gbb.gbbBrowser.emitCustomEvent === "function") {
      window.gbb.gbbBrowser.emitCustomEvent({ eventName: "gbb-footer-rendered" });
    }
    document.dispatchEvent(new CustomEvent("gbb-footer-rendered"));
    document.dispatchEvent(new CustomEvent("gbb-cart-updated"));
  }

  function getCurrentByogStyle() {
    try {
      // Prefer the stored box style (survives refresh/edit)
      if (typeof getBYOGBox === "function") {
        var box = getBYOGBox();
        if (box && box.style) return String(box.style);
      }
    } catch (e) {}

    // Fallback to in-memory style if available
    try {
      if (window.byogSelectedStyle) return String(window.byogSelectedStyle);
    } catch (e) {}

    return "";
  }

  function buildAddonItemFromVariantJson(parentItem, addonType, addonCfg, variantJson) {
    var parentTitle = parentItem.title || parentItem.product_title || parentItem.name || "Item";
    var displayTitle = parentTitle + " - " + addonType + " Personalisation";

    // Variant JSON usually has featured_image.src (or null)
    var img = (variantJson && variantJson.featured_image && variantJson.featured_image.src) ? variantJson.featured_image.src : "";
    // If variant JSON has no image, reuse parent image to avoid broken UI
    if (!img) img = parentItem.image || "";

    var qty = Number(parentItem.quantity || 1);
    var style = getCurrentByogStyle();

    return {
      id: Number(addonCfg.variant_id),
      quantity: qty,

      // These are used in EB UI / summary
      title: displayTitle,
      name: displayTitle,
      product_title: displayTitle,

      // Price in cents (use config as source of truth)
      price: Number(addonCfg.price),
      original_price: Number(addonCfg.price),
      originalPrice: Number(addonCfg.price),

      image: img,
      featured_image: img ? { src: img } : null,

      availableForSale: true,
      available: true,
      currentlyNotInStock: false,
      requiresShipping: false,

      variantId: Number(addonCfg.variant_id),
      variant_id: Number(addonCfg.variant_id),
      product_id: Number(addonCfg.product_id),
      sku: (variantJson && variantJson.sku) ? variantJson.sku : "",

      selectedOptions: [{ name: "Title", value: "Default Title" }],
      options: ["Default Title"],
      option1: "Default Title",
      public_title: "Default Title",

      properties: {
        _addon_product: true,
        _byog_parent_link: parentItem.properties._uniqueGbbItemKey,
        _byog_addon_type: addonType,

        // This is useful later when we push to Shopify cart
        _byog_display_title: displayTitle,

        _boxProduct: style || (parentItem.properties && parentItem.properties._boxProduct) || ""
      }
    };
  }

  document.addEventListener("click", function (e) {
    var addBtn = e.target && e.target.closest ? e.target.closest(".gbbProductVariantAddButton") : null;
    if (!addBtn) return;

    var modalEl = document.querySelector(".gbbProductVariantModalMainContainer");
    var choice = getChoice(modalEl);
    if (!choice || !ADDONS[choice]) return;

    var addonCfg = ADDONS[choice];

    // Let EB add the parent first
    setTimeout(function () {
      var data = read();
      if (!data || !data.boxes || !data.boxes[BOX] || !Array.isArray(data.boxes[BOX].items)) return;

      var box = data.boxes[BOX];
      var parentInfo = findLastSoftToyParent(box);
      if (!parentInfo) return;

      var parentItem = parentInfo.item;
      var parentLink = parentItem.properties && parentItem.properties._uniqueGbbItemKey;
      if (!parentLink) return;

      // Avoid duplicates on double click / rerender
      if (hasAddonForParent(box.items, parentLink, addonCfg.variant_id)) return;

      fetchVariantJson(addonCfg.variant_id).then(function (vJson) {
        var addonItem = buildAddonItemFromVariantJson(parentItem, choice, addonCfg, vJson);

        // Insert directly under parent
        box.items.splice(parentInfo.index + 1, 0, addonItem);

        // Recalc totals so footer updates from session storage values
        recalcTotals(data);

        if (!write(data)) return;
        emitRefresh();
      });
    }, 80);
  }, true);
})();
// END -- BYOG -- AUTO-ADD EMBROIDERY ADD-ON PRODUCTS

// --------------------------------------------------------------------
// START -- BYOG -- AUTO-ADD ADD-ON PRODUCTS (Soft Toy Backpack - single product)
// - Works ONLY for productid=9178178289901
// - Updates modal labels with price + hides OOS add-ons
// - Adds selected add-on as EB item right after the parent item in gbb-cart-1
// --------------------------------------------------------------------
(function () {
  var KEY = "gbb-cart-1";
  var BOX = "box1";

  // Target: ONLY this parent product
  var TARGET_PARENT_PRODUCT_ID = "9178178289901";

  var RADIO_FIELDKEY = "Soft Toy";

  // Your 10 add-ons (example structure). Replace with your real ones.
  // Keys must match the radio "value" exactly (the label choice).
  var ADDONS = {
    "Lovingly Signed Small Cream Twinkle Bunny": { product_id: 9238419308781, variant_id: 49218482536685, price: 2900 },
    "Steiff My First Steiff Teddy Bear - Goldblond": { product_id: 9077509947629, variant_id: 48557379420397, price: 6900 },
    "Steiff My First Steiff Teddy Bear - Pink": { product_id: 9077506605293, variant_id: 48557309559021, price: 6900 },
    "Steiff My First Steiff Teddy Bear - Blue": { product_id: 8990693458157, variant_id: 48068212883693, price: 6900 },
    "Maggie the Rabbit": { product_id: 8993757004013, variant_id: 48088289738989, price: 3800 },
    "Benedict the Rabbit": { product_id: 8993781514477, variant_id: 48088334598381, price: 3800 },
    "Edwina the Elephant": { product_id: 8993788985581, variant_id: 48088354160877, price: 4500 },
    "Myrtle the Elephant": { product_id: 8993803731181, variant_id: 48088394989805, price: 3200 },
    "Agatha the Rabbit": { product_id: 8993811300589, variant_id: 48088414847213, price: 3200 },
    "Lionel the Rabbit": { product_id: 8993824276717, variant_id: 48088438767853, price: 3200 }
  };

  // Cache variant JSON to avoid repeated requests
  var variantCache = {};
  var isUpdatingModalUI = false;
  var lastUiStamp = "";

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || ""); } catch (e) { return null; }
  }
  function write(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); return true; } catch (e) { return false; }
  }
  function normalize(s) {
    return String(s || "").trim();
  }

  // Money Helpers
  function getCurrencyRate() {
  try {
    var r = window.Shopify && Shopify.currency && Shopify.currency.rate ? Shopify.currency.rate : 1;
    var n = parseFloat(r);
    return isNaN(n) ? 1 : n;
  } catch (e) {
    return 1;
  }
}

function getMultipleCurrenciesInfoFromSettings() {
  try {
    // If you already have getSettings() globally (EB), use it
    if (typeof getSettings === "function") {
      var settings = getSettings();
      if (settings && settings.userData && settings.userData.multipleCurrenciesInfo) return settings.userData.multipleCurrenciesInfo;
      if (settings && settings.multipleCurrenciesInfo) return settings.multipleCurrenciesInfo;
    }
    if (window.tmpCartSettings2 && window.tmpCartSettings2.userData && window.tmpCartSettings2.userData.multipleCurrenciesInfo) {
      return window.tmpCartSettings2.userData.multipleCurrenciesInfo;
    }
  } catch (e) {}
  return null;
}

function getActiveCurrencyInfo() {
  try {
    var code = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!code) return null;

    var dict = getMultipleCurrenciesInfoFromSettings();
    if (!dict || !dict[code]) return null;

    return dict[code];
  } catch (e) {
    return null;
  }
}

function formatAmount(amount, info) {
  var digits = info.decimalDigits;
  var fixed = Number(amount).toFixed(digits);

  var parts = fixed.split(".");
  var intPart = parts[0];
  var decPart = parts[1] || "";

  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, info.thousandsSeparator);

  if (digits > 0) return intPart + info.decimalSeparator + decPart;
  return intPart;
}

function formatMoney(amount, info) {
  var formatted = formatAmount(amount, info);
  return info.symbol + formatted;
}
// END Money Helpers

  function fetchVariantJson(variantId) {
    var key = String(variantId);
    if (variantCache[key]) return Promise.resolve(variantCache[key]);

    return fetch("/variants/" + key + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        variantCache[key] = j;
        return j;
      })
      .catch(function () { return null; });
  }

  function recalcTotals(data) {
    if (!data || !data.boxes) return;

    var rootTotal = 0;
    var rootCount = 0;

    Object.keys(data.boxes).forEach(function (bk) {
      var b = data.boxes[bk];
      if (!b || !Array.isArray(b.items)) return;

      var boxTotal = 0;
      var boxCount = 0;

      for (var i = 0; i < b.items.length; i++) {
        var it = b.items[i];
        if (!it) continue;
        var q = Number(it.quantity || 0);
        var pr = Number(it.price || 0);
        boxTotal += q * pr;
        boxCount += q;
      }

      b.total_price = boxTotal;
      b.item_count = boxCount;

      rootTotal += boxTotal;
      rootCount += boxCount;
    });

    data.total_price = rootTotal;
    data.item_count = rootCount;
  }

  function emitRefresh() {
    if (window.gbb && window.gbb.gbbBrowser && typeof window.gbb.gbbBrowser.emitCustomEvent === "function") {
      window.gbb.gbbBrowser.emitCustomEvent({ eventName: "gbb-footer-rendered" });
    }
    document.dispatchEvent(new CustomEvent("gbb-footer-rendered"));
    document.dispatchEvent(new CustomEvent("gbb-cart-updated"));
  }

  function getCurrentByogStyle() {
    try {
      if (typeof getBYOGBox === "function") {
        var box = getBYOGBox();
        if (box && box.style) return String(box.style);
      }
    } catch (e) {}
    try {
      if (window.byogSelectedStyle) return String(window.byogSelectedStyle);
    } catch (e) {}
    return "";
  }

  // --- Modal helpers -------------------------------------------------

  function getActiveModal() {
    // You were using .gbbProductVariantModalMainContainer in the other script.
    // Keep it consistent.
    return document.querySelector(".gbbProductVariantModalMainContainer");
  }

  function getModalProductId(modalEl) {
    if (!modalEl) return "";
    // Try to find a container that actually has productid
    var withPid =
      modalEl.querySelector('.gbbProductVariantModalContainer[productid]') ||
      modalEl.querySelector('[productid]') ||
      null;
    if (!withPid) return "";
    return String(withPid.getAttribute("productid") || "");
  }

  function isTargetModal(modalEl) {
    return String(getModalProductId(modalEl)) === String(TARGET_PARENT_PRODUCT_ID);
  }

  function getChoice(modalEl) {
    if (!modalEl) return "";
    var radios = modalEl.querySelectorAll(
      'input.personalizationRadioInput[type="radio"][fieldkey="' + RADIO_FIELDKEY + '"]'
    );
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return normalize(radios[i].value);
    }
    return "";
  }

  function findRadioInput(modalEl, value) {
    if (!modalEl) return null;
    var selector =
      'input.personalizationRadioInput[type="radio"][fieldkey="' +
      RADIO_FIELDKEY +
      '"][value="' +
      CSS.escape(String(value)) +
      '"]';
    return modalEl.querySelector(selector);
  }

  function findRadioListItemForValue(modalEl, value) {
    var input = findRadioInput(modalEl, value);
    if (!input) return null;
    // In EB UI, the input is usually inside .gbbProductFormRadioListItem
    return input.closest ? input.closest(".gbbProductFormRadioListItem") : null;
  }

  function cssEscapeSafe(s) {
    return String(s).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function safeSetRadioLabelHtml(modalEl, value, html) {
    if (!modalEl) return;

    var valEsc = (window.CSS && typeof window.CSS.escape === "function")
      ? window.CSS.escape(String(value))
      : cssEscapeSafe(value);

    var input = modalEl.querySelector(
      '.gbbProductFormRadioListItems input.personalizationRadioInput[type="radio"][fieldkey="' +
        RADIO_FIELDKEY +
        '"][value="' +
        valEsc +
        '"]'
    );
    if (!input) return;

    var label = input.closest("label");
    if (!label) return;

    // IMPORTANT: target the SAME span pattern you already use in Soft Toys
    var span =
      label.querySelector('span.personalizationRadioLabel[fieldkey="' + RADIO_FIELDKEY + '"]') ||
      label.querySelector("span.personalizationRadioLabel") ||
      null;

    if (!span) return;

    // Avoid needless rewrites (prevents extra mutation churn)
    if (span.innerHTML === html) return;

    span.innerHTML = html;
  }

  function updateModalAddonsUI(modalEl) {
    if (!modalEl || !isTargetModal(modalEl)) return;

    var info = getActiveCurrencyInfo();

    Object.keys(ADDONS).forEach(function (choiceValue) {
      var cfg = ADDONS[choiceValue];
      if (!cfg || !cfg.variant_id) return;

      fetchVariantJson(cfg.variant_id).then(function (vJson) {
        // If fetch failed, do not destroy UI; just fallback to cfg.price and keep visible
        var fetched = !!vJson;

        var available = fetched ? !!vJson.available : true;

        var priceCents = (vJson && typeof vJson.price === "number")
          ? vJson.price
          : Number(cfg.price || 0);

        // No rate multiplication
        var amount = priceCents / 100;

        var prettyPrice = info
          ? formatMoney(amount, info)
          : amount.toFixed(2);

        var html =
          '<span class="gbbAddonLabelText">' + String(choiceValue) + '</span>' +
          ' <span class="personalisation-fee">(+ ' + prettyPrice + ')</span>';

        safeSetRadioLabelHtml(modalEl, choiceValue, html);

        var li = findRadioListItemForValue(modalEl, choiceValue);
        if (li) li.style.display = available ? "" : "none";
      });
    });
  }

  // Update UI when modal appears / rerenders (MutationObserver)
  var modalObserver = new MutationObserver(function () {
    if (isUpdatingModalUI) return;

    var modalEl = getActiveModal();
    if (!modalEl || !isTargetModal(modalEl)) return;

    // Debounce-ish: avoid hammering on rapid DOM changes
    var stamp = String(modalEl.innerHTML.length); // cheap-ish fingerprint
    if (stamp === lastUiStamp) return;
    lastUiStamp = stamp;

    // Run async so multiple mutations collapse into one update
    setTimeout(function () {
      if (isUpdatingModalUI) return;
      isUpdatingModalUI = true;
      try {
        updateModalAddonsUI(modalEl);
      } finally {
        isUpdatingModalUI = false;
      }
    }, 0);
  });

  modalObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // --- Cart insertion helpers ---------------------------------------

  function findLastTargetParent(box) {
    var items = box && box.items;
    if (!Array.isArray(items) || !items.length) return null;

    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i];
      if (!it) continue;

      var p = it.properties || {};
      if (p._addon_product) continue;
      if (!p._uniqueGbbItemKey) continue;

      // Match ONLY the target parent product
      // (EB items usually have product_id)
      if (String(it.product_id || "") !== String(TARGET_PARENT_PRODUCT_ID)) continue;

      return { item: it, index: i };
    }
    return null;
  }

  function hasAddonForParent(items, parentLink, addonVariantId) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.properties) continue;
      if (!it.properties._addon_product) continue;
      if (String(it.variant_id) !== String(addonVariantId)) continue;
      if (String(it.properties._byog_parent_link || "") === String(parentLink)) return true;
    }
    return false;
  }

  function buildAddonItemFromVariantJson(parentItem, addonType, addonCfg, variantJson) {
    var parentTitle = parentItem.title || parentItem.product_title || parentItem.name || "Item";
    var displayTitle = parentTitle + " - " + addonType;

    var img = (variantJson && variantJson.featured_image && variantJson.featured_image.src) ? variantJson.featured_image.src : "";
    if (!img) img = parentItem.image || "";

    var qty = Number(parentItem.quantity || 1);
    var style = getCurrentByogStyle();

    var priceCents = (variantJson && typeof variantJson.price === "number") ? variantJson.price : Number(addonCfg.price || 0);

    return {
      id: Number(addonCfg.variant_id),
      quantity: qty,

      title: displayTitle,
      name: displayTitle,
      product_title: displayTitle,

      price: Number(priceCents),
      original_price: Number(priceCents),
      originalPrice: Number(priceCents),

      image: img,
      featured_image: img ? { src: img } : null,

      availableForSale: true,
      available: true,
      currentlyNotInStock: false,
      requiresShipping: false,

      variantId: Number(addonCfg.variant_id),
      variant_id: Number(addonCfg.variant_id),
      product_id: Number(addonCfg.product_id),
      sku: (variantJson && variantJson.sku) ? variantJson.sku : "",

      selectedOptions: [{ name: "Title", value: "Default Title" }],
      options: ["Default Title"],
      option1: "Default Title",
      public_title: "Default Title",

      properties: {
        _addon_product: true,
        _byog_parent_link: parentItem.properties._uniqueGbbItemKey,
        _byog_addon_type: addonType,
        _byog_display_title: displayTitle,
        _boxProduct: style || (parentItem.properties && parentItem.properties._boxProduct) || ""
      }
    };
  }

  // Add-on insert on click "Add" in modal
  document.addEventListener("click", function (e) {
    var addBtn = e.target && e.target.closest ? e.target.closest(".gbbProductVariantAddButton") : null;
    if (!addBtn) return;

    var modalEl = getActiveModal();
    if (!modalEl || !isTargetModal(modalEl)) return;

    var choice = getChoice(modalEl);
    if (!choice || !ADDONS[choice]) return;

    var addonCfg = ADDONS[choice];

    // Let EB add the parent first
    setTimeout(function () {
      var data = read();
      if (!data || !data.boxes || !data.boxes[BOX] || !Array.isArray(data.boxes[BOX].items)) return;

      var box = data.boxes[BOX];
      var parentInfo = findLastTargetParent(box);
      if (!parentInfo) return;

      var parentItem = parentInfo.item;
      var parentLink = parentItem.properties && parentItem.properties._uniqueGbbItemKey;
      if (!parentLink) return;

      if (hasAddonForParent(box.items, parentLink, addonCfg.variant_id)) return;

      fetchVariantJson(addonCfg.variant_id).then(function (vJson) {
        // If variant is OOS, do not add (extra safety)
        if (vJson && vJson.available === false) return;

        var addonItem = buildAddonItemFromVariantJson(parentItem, choice, addonCfg, vJson);

        box.items.splice(parentInfo.index + 1, 0, addonItem);

        recalcTotals(data);
        if (!write(data)) return;

        emitRefresh();
      });
    }, 80);
  }, true);
})();
// END -- BYOG -- AUTO-ADD ADD-ON PRODUCTS (Backpacks - single product)

// --------------------------------------------------------------------
// START -- BYOG -- DISABLE UNAVAILABLE COMBINATIONS
(function () {
  function getModalEl() {
    return document.querySelector(".gbbProductVariantModalContainer");
  }

  function getSelectedMapFromDOM(modalEl) {
    const map = {};
    if (!modalEl) return map;

    modalEl.querySelectorAll(".gbbProductVariantOptionContainer").forEach((optContainer) => {
      const optionNameEl = optContainer.querySelector(".gbbProductVariantOptionLabel");
      const activeValueEl = optContainer.querySelector(".gbbProductVariantOptionValue.gbbActiveVariant");

      const optionName = optionNameEl ? optionNameEl.textContent.trim() : "";
      const optionValue = activeValueEl ? activeValueEl.textContent.trim() : "";

      if (optionName && optionValue) map[optionName] = optionValue;
    });

    return map;
  }

  // Checks if there exists at least one available variant that contains all required values.
  function hasCompatibleAvailableVariant(product, requiredValues) {
    if (!product || !Array.isArray(product.variants)) return false;

    return product.variants.some((v) => {
      const opts = Array.isArray(v.options) ? v.options : [];
      const isAvailable = String(v.available) === "1" || v.available === true;

      // Optional: if quantityAvailable exists, also require > 0.
      const qtyOk = (typeof v.quantityAvailable === "number") ? v.quantityAvailable > 0 : true;

      if (!isAvailable || !qtyOk) return false;

      return requiredValues.every((val) => opts.includes(val));
    });
  }

  function setValueDisabled(valueEl, disabled) {
    if (!valueEl) return;
    valueEl.classList.toggle("gbbVariantValueDisabled", !!disabled);
    valueEl.setAttribute("aria-disabled", disabled ? "true" : "false");
  }

  function refreshDisabledStates() {
    const modalEl = getModalEl();
    if (!modalEl) return;

    const product = window.gbb?.state?.currentModalProductData;
    if (!product) return;

    const selectedMap = getSelectedMapFromDOM(modalEl);

    // For each option group, test each value against: (selected values from other groups) + (this candidate value)
    modalEl.querySelectorAll(".gbbProductVariantOptionContainer").forEach((optContainer) => {
      const optionNameEl = optContainer.querySelector(".gbbProductVariantOptionLabel");
      const optionName = optionNameEl ? optionNameEl.textContent.trim() : "";
      if (!optionName) return;

      // Values chosen in other option groups (exclude this group)
      const baseValues = Object.entries(selectedMap)
        .filter(([name]) => name !== optionName)
        .map(([, val]) => val);

      optContainer.querySelectorAll(".gbbProductVariantOptionValue").forEach((valueEl) => {
        const candidateValue = valueEl.textContent.trim();
        const requiredValues = baseValues.concat(candidateValue);

        const ok = hasCompatibleAvailableVariant(product, requiredValues);

        // Disable if there is NO compatible available variant
        setValueDisabled(valueEl, !ok);
      });
    });
  }

  // Run when modal opens (Easy Bundles emits this event)
  document.addEventListener("gbb-variants-modal-open", function () {
    // Give it a tick to finish rendering
    setTimeout(refreshDisabledStates, 0);
  });

  // Run after each click on a variant value (event delegation)
  document.addEventListener("click", function (e) {
    const valueEl = e.target && e.target.closest && e.target.closest(".gbbProductVariantOptionValue");
    if (!valueEl) return;

    // After Easy Bundles updates "active" classes, recompute
    setTimeout(refreshDisabledStates, 0);
  });
})();
// END -- BYOG -- DISABLE UNAVAILABLE COMBINATIONS

// --------------------------------------------------------------------
// START -- BYOG -- PARENT CAPS PERSONALISATION FILTER
// Opens the modal for any product from the "Mama Caps (hidden)" or
// "Dad Caps (hidden)" category and:
//   - Hides: "Name", " Embroidery Font", "Thread Colour"
//   - Converts: "Add Personalised Name on the Back of the Cap" radio → checkbox behaviour
//   - Shows/hides "Name on the Back" based on checkbox state
//   - Updates the price label using active currency
// --------------------------------------------------------------------
(function () {
  var CATEGORY_CONFIGS = [
    {
      title:       "Mama Caps (hidden)",
      indexKey:    "byog_mama_caps_index_v1",
      globalIndex: "__byogMamaCapsIndex"
    },
    {
      title:       "Dad Caps (hidden)",
      indexKey:    "byog_dad_caps_index_v1",
      globalIndex: "__byogDadCapsIndex"
    }
  ];

  var FIELDKEY_CHECKBOX  = "Name on the Back";
  var FIELDKEY_NAME_BACK = "Name to Embroider";

  // Add-on price in cents (used only for the label – the actual insert is in the next IIFE)
  var ADDON_PRICE_CENTS = 1500;

  var indexBuilt = false;

  // ── helpers ──────────────────────────────────────────────────────────

  function normalize(s) { return String(s || "").trim().toLowerCase(); }

  function getSettings() {
    return window.tmpCartSettings2 || window.tmpCartSettings || null;
  }

  function tryLoadIndexFromSession(indexKey) {
    try { var r = sessionStorage.getItem(indexKey); return r ? JSON.parse(r) : null; }
    catch (e) { return null; }
  }

  function saveIndexToSession(indexKey, obj) {
    try { sessionStorage.setItem(indexKey, JSON.stringify(obj)); } catch (e) {}
  }

  function collectCategories(settings) {
    var out = [];
    function walk(node) {
      if (!node || typeof node !== "object") return;
      if (node.categoryId && node.title && Array.isArray(node.products)) out.push(node);
      for (var k in node) {
        if (!Object.prototype.hasOwnProperty.call(node, k)) continue;
        var v = node[k];
        if (!v || typeof v !== "object") continue;
        if (Array.isArray(v)) { for (var i = 0; i < v.length; i++) walk(v[i]); }
        else walk(v);
      }
    }
    walk(settings);
    return out;
  }

  function buildIndexOnce() {
    if (indexBuilt) return;

    var allLoadedFromSession = true;
    for (var i = 0; i < CATEGORY_CONFIGS.length; i++) {
      var config = CATEGORY_CONFIGS[i];
      var fromSession = tryLoadIndexFromSession(config.indexKey);
      var hasCachedProducts = fromSession && fromSession.productIds &&
        Object.keys(fromSession.productIds).length > 0;
      if (hasCachedProducts && normalize(fromSession.categoryTitle) === normalize(config.title)) {
        window[config.globalIndex] = fromSession;
      } else {
        allLoadedFromSession = false;
      }
    }
    if (allLoadedFromSession) { indexBuilt = true; return; }

    var settings = getSettings();
    if (!settings) return;

    var categories = collectCategories(settings);
    for (var cfgIndex = 0; cfgIndex < CATEGORY_CONFIGS.length; cfgIndex++) {
      var cfg        = CATEGORY_CONFIGS[cfgIndex];
      var wanted     = normalize(cfg.title);
      var productIds = {};

      for (var c = 0; c < categories.length; c++) {
        var cat = categories[c];
        if (normalize(cat.title) !== wanted) continue;
        for (var p = 0; p < cat.products.length; p++) {
          var prod = cat.products[p];
          if (prod && prod.productId) productIds[String(prod.productId)] = true;
        }
      }

      var indexObj = { categoryTitle: cfg.title, productIds: productIds };
      window[cfg.globalIndex] = indexObj;
      saveIndexToSession(cfg.indexKey, indexObj);
    }
    indexBuilt = CATEGORY_CONFIGS.every(function (config) {
      var idx = window[config.globalIndex];
      return idx && idx.productIds && Object.keys(idx.productIds).length > 0;
    });
  }

  // ── currency helpers (self-contained, mirrors Soft Toys pattern) ─────

  function getCurrencyRate() {
    try {
      var r = window.Shopify && Shopify.currency && Shopify.currency.rate ? Shopify.currency.rate : 1;
      var n = parseFloat(r);
      return isNaN(n) ? 1 : n;
    } catch (e) { return 1; }
  }

  function getMultiCurrencyInfo() {
    var s = getSettings();
    if (s && s.userData && s.userData.multipleCurrenciesInfo) return s.userData.multipleCurrenciesInfo;
    if (s && s.multipleCurrenciesInfo) return s.multipleCurrenciesInfo;
    return null;
  }

  function getActiveCurrencyInfo() {
    try {
      var code = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (!code) return null;
      var dict = getMultiCurrencyInfo();
      return (dict && dict[code]) ? dict[code] : null;
    } catch (e) { return null; }
  }

  function formatAmount(amount, info) {
    var fixed = Number(amount).toFixed(info.decimalDigits);
    var parts  = fixed.split(".");
    parts[0]   = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, info.thousandsSeparator);
    return info.decimalDigits > 0 ? parts[0] + info.decimalSeparator + (parts[1] || "") : parts[0];
  }

  function formatMoney(amount, info) {
    return info.symbol + formatAmount(amount, info);
  }

  function formatAddonPrice() {
    var info = getActiveCurrencyInfo();
    if (!info) return "$" + (ADDON_PRICE_CENTS / 100).toFixed(2);
    var converted = (ADDON_PRICE_CENTS / 100) * getCurrencyRate();
    return formatMoney(converted, info);
  }

  // ── modal DOM helpers ─────────────────────────────────────────────────

  function getModalContainer() {
    var modals = document.querySelectorAll(
      ".gbbProductVariantModalContainer.gbbProductVariantModalContainerWithPersonalization"
    );
    if (!modals.length) return null;

    // Easy Bundles can leave an older modal in the DOM. Prefer the modal whose
    // product matches the product currently tracked by Easy Bundles.
    var currentProduct = window.gbb && window.gbb.state && window.gbb.state.currentModalProductData;
    var currentPid = currentProduct && (currentProduct.productId || currentProduct.product_id || currentProduct.id);
    if (currentPid) {
      for (var i = modals.length - 1; i >= 0; i--) {
        if (String(getModalProductId(modals[i])) === String(currentPid)) return modals[i];
      }
    }

    // Otherwise use the last visible modal, then fall back to the newest one.
    for (var j = modals.length - 1; j >= 0; j--) {
      if (modals[j].getClientRects().length > 0) return modals[j];
    }
    return modals[modals.length - 1];
  }

  function getModalProductId(modalEl) {
    if (!modalEl) return null;
    return modalEl.getAttribute("productid") || modalEl.getAttribute("productId") || null;
  }

  function isCapProduct(pid) {
    for (var i = 0; i < CATEGORY_CONFIGS.length; i++) {
      var idx = window[CATEGORY_CONFIGS[i].globalIndex];
      if (idx && idx.productIds && idx.productIds[String(pid)]) return true;
    }
    return false;
  }

  function setFieldVisible(modalEl, fieldkey, visible) {
    var selectors = [
      '.gbbProductFormTextContainer[fieldkey="'          + fieldkey + '"]',
      '.gbbProductFormRadioContainer[fieldkey="'         + fieldkey + '"]',
      '.gbbProductFormImageSelectorContainer[fieldkey="' + fieldkey + '"]'
    ];
    selectors.forEach(function (sel) {
      modalEl.querySelectorAll(sel).forEach(function (el) {
        el.style.display = visible ? "" : "none";
      });
    });
  }

  function updateNameOnBackVisibility(modalEl) {
    var input = modalEl.querySelector(
      'input[fieldkey="' + FIELDKEY_CHECKBOX + '"]'
    );
    var checked = input ? input.checked : false;
    setFieldVisible(modalEl, FIELDKEY_NAME_BACK, checked);
  }

  function updateCheckboxPriceLabel(modalEl) {
    var span = modalEl.querySelector(
      'span.personalizationRadioLabel[fieldkey="' + FIELDKEY_CHECKBOX + '"]'
    );
    if (!span) return;
    span.innerHTML = 'Add Personalised Name on the Back of the Cap ' +
      '<span class="personalisation-fee">(+ ' + formatAddonPrice() + ')</span>';
  }

  function convertRadioToCheckbox(modalEl) {
    if (modalEl.__byogCapCheckboxDone) return;
    modalEl.__byogCapCheckboxDone = true;

    var input = modalEl.querySelector(
      'input.personalizationRadioInput[type="radio"][fieldkey="' + FIELDKEY_CHECKBOX + '"]'
    );
    if (!input) return;

    // Change to checkbox so it toggles natively
    input.type = "checkbox";

    // Track state before click so we can detect "uncheck" (radio → checkbox transitional)
    var stateBeforeClick = false;

    function handleMousedown() { stateBeforeClick = input.checked; }

    input.addEventListener("mousedown", handleMousedown);

    // Also capture mousedown on the label (label click → input mousedown doesn't always fire)
    var label = input.closest("label");
    if (label) label.addEventListener("mousedown", handleMousedown);

    input.addEventListener("click", function () {
      // If it was already checked, we need to uncheck it explicitly
      // (browsers handle this automatically for checkboxes, but belt + braces)
      updateNameOnBackVisibility(modalEl);
    });

    input.addEventListener("change", function () {
      updateNameOnBackVisibility(modalEl);
    });
  }

  // ── main filter entry point ───────────────────────────────────────────

  function applyCapModalFilter() {
    buildIndexOnce();

    var modalEl = getModalContainer();
    if (!modalEl) return;

    var pid = getModalProductId(modalEl);
    if (!pid || !isCapProduct(pid)) return;

    // Mark modal so external CSS / JS can target cap modals specifically
    modalEl.setAttribute("data-byog-product", "cap");

    // Update price label with localised amount
    setTimeout(function () {
      requestAnimationFrame(function () { updateCheckboxPriceLabel(modalEl); });
    }, 0);

    // Convert "Add Name" radio → checkbox and wire show/hide
    convertRadioToCheckbox(modalEl);

    // Initial state: hide "Name on the Back" until checkbox is ticked
    updateNameOnBackVisibility(modalEl);
  }

  function hideParentCapsCategories() {
    document.querySelectorAll("option").forEach(function (option) {
      var title = normalize(option.textContent);
      for (var i = 0; i < CATEGORY_CONFIGS.length; i++) {
        if (title === normalize(CATEGORY_CONFIGS[i].title)) {
          option.remove();
          return;
        }
      }
    });
  }

  // ── boot ─────────────────────────────────────────────────────────────

  if (typeof waitForHtmlClasses === "function") {
    waitForHtmlClasses(function () {

      buildIndexOnce();

      const observer = new MutationObserver(function () {
        hideParentCapsCategories();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }

  document.addEventListener("gbb-variants-modal-open", function () {
    setTimeout(applyCapModalFilter, 0);
  });
})();
// END -- BYOG -- PARENT CAPS PERSONALISATION FILTER

// --------------------------------------------------------------------
// START -- BYOG -- AUTO-ADD NAME ON BACK ADD-ON (Mama & Dad Caps)
// When the user ticks "Add Personalised Name on the Back of the Cap" and
// clicks Add in the modal, injects the add-on as an EB item in gbb-cart-1
// immediately after the parent cap item, then recalculates totals.
// --------------------------------------------------------------------
(function () {
  var KEY = "gbb-cart-1";
  var BOX = "box1";

  var FIELDKEY_CHECKBOX = "Name on the Back";

  var ADDON_CFG = {
    product_id: 9366687645933,
    variant_id: 49970429296877,
    price:      1500
  };

  var variantCache = {};

  // ── storage helpers ───────────────────────────────────────────────────

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || ""); } catch (e) { return null; }
  }
  function write(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); return true; } catch (e) { return false; }
  }

  // ── modal detection ───────────────────────────────────────────────────
  // The filter IIFE converts the radio to a checkbox only for cap products,
  // so finding input[type="checkbox"] with this fieldkey is a reliable guard.

  function isCapModalOpen() {
    return !!document.querySelector('input[type="checkbox"][fieldkey="' + FIELDKEY_CHECKBOX + '"]');
  }

  function isCheckboxChecked() {
    var input = document.querySelector('input[type="checkbox"][fieldkey="' + FIELDKEY_CHECKBOX + '"]');
    return input ? input.checked : false;
  }

  // Fallback: match by product_id via the index built by the filter IIFE
  function isCapProductById(pid) {
    var indexes = [window.__byogMamaCapsIndex, window.__byogDadCapsIndex];
    for (var i = 0; i < indexes.length; i++) {
      var idx = indexes[i];
      if (idx && idx.productIds && idx.productIds[String(pid)]) return true;
    }
    return false;
  }

  // ── cart helpers ──────────────────────────────────────────────────────

  function findLastCapParent(box) {
    var items = box && box.items;
    if (!Array.isArray(items) || !items.length) return null;
    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i];
      if (!it) continue;
      var p = it.properties || {};
      if (p._addon_product) continue;
      if (!p._uniqueGbbItemKey) continue;
      // Detect caps via product index (items are added from "Gifts for Mum", not the hidden category)
      if (!isCapProductById(String(it.product_id || ""))) continue;
      return { item: it, index: i };
    }
    return null;
  }

  function hasAddonForParent(items, parentLink, addonVariantId) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.properties || !it.properties._addon_product) continue;
      if (String(it.variant_id) !== String(addonVariantId)) continue;
      if (String(it.properties._byog_parent_link || "") === String(parentLink)) return true;
    }
    return false;
  }

  function getConvertedPriceCents(baseCents) {
    try {
      var r = window.Shopify && Shopify.currency && Shopify.currency.rate ? parseFloat(Shopify.currency.rate) : 1;
      if (isNaN(r) || r <= 0) r = 1;
      return Math.round(baseCents * r);
    } catch (e) { return baseCents; }
  }

  function fetchVariantJson(variantId) {
    var key = String(variantId);
    if (variantCache[key]) return Promise.resolve(variantCache[key]);
    return fetch("/variants/" + key + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { variantCache[key] = j; return j; })
      .catch(function () { return null; });
  }

  function recalcTotals(data) {
    if (!data || !data.boxes) return;
    var rootTotal = 0, rootCount = 0;
    Object.keys(data.boxes).forEach(function (bk) {
      var b = data.boxes[bk];
      if (!b || !Array.isArray(b.items)) return;
      var boxTotal = 0, boxCount = 0;
      for (var i = 0; i < b.items.length; i++) {
        var it = b.items[i];
        if (!it) continue;
        boxTotal += Number(it.quantity || 0) * Number(it.price || 0);
        boxCount += Number(it.quantity || 0);
      }
      b.total_price = boxTotal;
      b.item_count  = boxCount;
      rootTotal += boxTotal;
      rootCount += boxCount;
    });
    data.total_price = rootTotal;
    data.item_count  = rootCount;
  }

  function emitRefresh() {
    if (window.gbb && window.gbb.gbbBrowser && typeof window.gbb.gbbBrowser.emitCustomEvent === "function") {
      window.gbb.gbbBrowser.emitCustomEvent({ eventName: "gbb-footer-rendered" });
    }
    document.dispatchEvent(new CustomEvent("gbb-footer-rendered"));
    document.dispatchEvent(new CustomEvent("gbb-cart-updated"));
  }

  function getCurrentByogStyle() {
    try {
      if (typeof getBYOGBox === "function") { var b = getBYOGBox(); if (b && b.style) return String(b.style); }
    } catch (e) {}
    try { if (window.byogSelectedStyle) return String(window.byogSelectedStyle); } catch (e) {}
    return "";
  }

  function buildAddonItem(parentItem, addonCfg, variantJson) {
    var parentTitle   = parentItem.title || parentItem.product_title || parentItem.name || "Item";
    var displayTitle  = parentTitle + " - Name on the Back";
    var img = (variantJson && variantJson.featured_image && variantJson.featured_image.src)
      ? variantJson.featured_image.src
      : (parentItem.image || "");
    var qty           = Number(parentItem.quantity || 1);
    var style         = getCurrentByogStyle();
    var convertedPrice = getConvertedPriceCents(Number(addonCfg.price));

    return {
      id:               Number(addonCfg.variant_id),
      quantity:         qty,
      title:            displayTitle,
      name:             displayTitle,
      product_title:    displayTitle,
      price:            convertedPrice,
      original_price:   convertedPrice,
      originalPrice:    convertedPrice,
      image:            img,
      featured_image:   img ? { src: img } : null,
      availableForSale: true,
      available:        true,
      currentlyNotInStock: false,
      requiresShipping: false,
      variantId:        Number(addonCfg.variant_id),
      variant_id:       Number(addonCfg.variant_id),
      product_id:       Number(addonCfg.product_id),
      sku:              (variantJson && variantJson.sku) ? variantJson.sku : "",
      selectedOptions:  [{ name: "Title", value: "Default Title" }],
      options:          ["Default Title"],
      option1:          "Default Title",
      public_title:     "Default Title",
      properties: {
        _addon_product:       true,
        _byog_parent_link:    parentItem.properties._uniqueGbbItemKey,
        _byog_addon_type:     "Name on the Back",
        _byog_display_title:  displayTitle,
        _boxProduct:          style || (parentItem.properties && parentItem.properties._boxProduct) || ""
      }
    };
  }

  // ── click handler ─────────────────────────────────────────────────────

  document.addEventListener("click", function (e) {
    var addBtn = e.target && e.target.closest ? e.target.closest(".gbbProductVariantAddButton") : null;
    if (!addBtn) return;

    if (!isCapModalOpen()) return;
    if (!isCheckboxChecked()) return;

    // Let EB write the parent item to storage first
    setTimeout(function () {
      var data = read();
      if (!data || !data.boxes || !data.boxes[BOX] || !Array.isArray(data.boxes[BOX].items)) return;

      var box        = data.boxes[BOX];
      var parentInfo = findLastCapParent(box);
      if (!parentInfo) return;

      var parentItem = parentInfo.item;
      var parentLink = parentItem.properties && parentItem.properties._uniqueGbbItemKey;
      if (!parentLink) return;

      if (hasAddonForParent(box.items, parentLink, ADDON_CFG.variant_id)) return;

      fetchVariantJson(ADDON_CFG.variant_id).then(function (vJson) {
        var addonItem = buildAddonItem(parentItem, ADDON_CFG, vJson);

        // Insert directly after parent
        box.items.splice(parentInfo.index + 1, 0, addonItem);

        recalcTotals(data);
        if (!write(data)) return;

        emitRefresh();

        // Sync footer total display
        if (typeof byogUpdateFooterTotalFromStorage === "function") {
          byogUpdateFooterTotalFromStorage();
        }
      });
    }, 80);
  }, true);
})();
// END -- BYOG -- AUTO-ADD NAME ON BACK ADD-ON (Mama & Dad Caps)

// --------------------------------------------------------------------

// START -- BYOG -- P15 / P20 PERSONALISATION FILTER AND ADD-ON
(function () {
  var FIELDKEY_CHECKBOX = "Add Personalisation";
  var KEY = "gbb-cart-1";
  var BOX = "box1";
  var variantCache = {};
  var CONFIG = {
    p15: { product_id: 9153545437421, variant_id: 48911415705837, price: 1500 },
    p20: { product_id: 9153545437421, variant_id: 49118975066349, price: 2000 }
  };

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || ""); } catch (e) { return null; }
  }
  function write(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); return true; } catch (e) { return false; }
  }
  function productId(product) {
    return product && String(product.productId || product.product_id || product.id || "");
  }
  function configForProduct(pid) {
    var tags = {};
    var seen = new WeakSet();
    function walk(node) {
      if (!node || typeof node !== "object" || seen.has(node)) return;
      seen.add(node);
      if (productId(node) === String(pid)) {
        var list = Array.isArray(node.tags) ? node.tags : String(node.tags || "").split(",");
        list.forEach(function (tag) { tags[String(tag).trim().toLowerCase()] = true; });
      }
      Object.keys(node).forEach(function (key) {
        if (node[key] && typeof node[key] === "object") walk(node[key]);
      });
    }
    walk(window.tmpCartSettings2 || window.tmpCartSettings);
    walk(window.gbb && window.gbb.state && window.gbb.state.currentModalProductData);
    // Prefer p20 if both tags are present. Do not cache: settings can arrive late.
    return tags.p20 ? CONFIG.p20 : tags.p15 ? CONFIG.p15 : null;
  }
  function priceLabel(cents) {
    var currency = window.Shopify && window.Shopify.currency;
    var code = currency && currency.active;
    var settings = window.tmpCartSettings2 || window.tmpCartSettings || {};
    var currencies = (settings.userData && settings.userData.multipleCurrenciesInfo) || settings.multipleCurrenciesInfo;
    var info = currencies && currencies[code];
    var amount = getConvertedPriceCents(cents) / 100;
    if (info) {
      var digits = Number(info.decimalDigits) || 0;
      var parts = amount.toFixed(digits).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, info.thousandsSeparator || "");
      var formatted = parts[0] + (digits ? (info.decimalSeparator || ".") + parts[1] : "");
      var space = info.spaceBetweenAmountAndSymbol ? " " : "";
      return info.symbolOnLeft === false ? formatted + space + info.symbol : info.symbol + space + formatted;
    }
    if (code) {
      try { return new Intl.NumberFormat(undefined, { style: "currency", currency: code, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount); } catch (e) {}
    }
    return "$" + amount;
  }
  var fieldSelector = '.gbbProductFormContainer > [fieldkey], .gbbProductFormTextContainer[fieldkey], .gbbProductFormRadioContainer[fieldkey], .gbbProductFormImageSelectorContainer[fieldkey]';
  function applyModal(modal) {
    var pid = modal.getAttribute("productid");
    var cfg = pid && configForProduct(pid);
    var input = modal.querySelector('input[fieldkey="' + FIELDKEY_CHECKBOX + '"]');
    if (!input) return;
    var control = input.closest('.gbbProductFormRadioContainer') || input.closest('.gbbProductFormRadioListItem');
    if (control) control.style.setProperty("display", cfg ? "" : "none", cfg ? "" : "important");
    if (!cfg) return;
    if (!input.__byogPersonalisationBound) {
      input.type = "checkbox";
      input.__byogPersonalisationBound = true;
      input.addEventListener("change", function () { applyModal(modal); });
    }
    var span = input.closest("label") && input.closest("label").querySelector(".personalizationRadioLabel");
    var feeText = "(+ " + priceLabel(cfg.price) + ")";
    if (span) {
      var fee = span.querySelector(".personalisation-fee");
      if (!fee) {
        span.textContent = FIELDKEY_CHECKBOX + " ";
        fee = document.createElement("span");
        fee.className = "personalisation-fee";
        span.appendChild(fee);
      }
      if (fee.textContent !== feeText) fee.textContent = feeText;
    }
    modal.querySelectorAll(fieldSelector).forEach(function (field) {
      if (field === control || field.contains(input) || field.getAttribute("fieldkey") === FIELDKEY_CHECKBOX) return;
      // Override theme rules that normally hide embroidery fields by default.
      var display = input.checked ? "revert" : "none";
      if (field.style.getPropertyValue("display") !== display) field.style.setProperty("display", display, "important");
    });
  }
  function applyAll() {
    document.querySelectorAll(".gbbProductVariantModalContainer").forEach(applyModal);
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; applyAll(); }, 0);
  }
  function boot() {
    applyAll();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("gbb-variants-modal-open", schedule);

  function hasAddonForParent(items, parentLink, addonVariantId) {
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || !it.properties || !it.properties._addon_product) continue;
      if (String(it.variant_id) !== String(addonVariantId)) continue;
      if (String(it.properties._byog_parent_link || "") === String(parentLink)) return true;
    }
    return false;
  }

  function getConvertedPriceCents(baseCents) {
    try {
      var r = window.Shopify && Shopify.currency && Shopify.currency.rate ? parseFloat(Shopify.currency.rate) : 1;
      if (isNaN(r) || r <= 0) r = 1;
      return Math.round(baseCents * r);
    } catch (e) { return baseCents; }
  }

  function fetchVariantJson(variantId) {
    var key = String(variantId);
    if (variantCache[key]) return Promise.resolve(variantCache[key]);
    return fetch("/variants/" + key + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { variantCache[key] = j; return j; })
      .catch(function () { return null; });
  }

  function recalcTotals(data) {
    if (!data || !data.boxes) return;
    var rootTotal = 0, rootCount = 0;
    Object.keys(data.boxes).forEach(function (bk) {
      var b = data.boxes[bk];
      if (!b || !Array.isArray(b.items)) return;
      var boxTotal = 0, boxCount = 0;
      for (var i = 0; i < b.items.length; i++) {
        var it = b.items[i];
        if (!it) continue;
        boxTotal += Number(it.quantity || 0) * Number(it.price || 0);
        boxCount += Number(it.quantity || 0);
      }
      b.total_price = boxTotal;
      b.item_count  = boxCount;
      rootTotal += boxTotal;
      rootCount += boxCount;
    });
    data.total_price = rootTotal;
    data.item_count  = rootCount;
  }

  function emitRefresh() {
    if (window.gbb && window.gbb.gbbBrowser && typeof window.gbb.gbbBrowser.emitCustomEvent === "function") {
      window.gbb.gbbBrowser.emitCustomEvent({ eventName: "gbb-footer-rendered" });
    }
    document.dispatchEvent(new CustomEvent("gbb-footer-rendered"));
    document.dispatchEvent(new CustomEvent("gbb-cart-updated"));
  }

  function getCurrentByogStyle() {
    try {
      if (typeof getBYOGBox === "function") { var b = getBYOGBox(); if (b && b.style) return String(b.style); }
    } catch (e) {}
    try { if (window.byogSelectedStyle) return String(window.byogSelectedStyle); } catch (e) {}
    return "";
  }

  function buildAddonItem(parentItem, addonCfg, variantJson) {
    var parentTitle   = parentItem.title || parentItem.product_title || parentItem.name || "Item";
    var displayTitle  = parentTitle + " - Personalisation";
    var img = (variantJson && variantJson.featured_image && variantJson.featured_image.src)
      ? variantJson.featured_image.src
      : (parentItem.image || "");
    var qty           = Number(parentItem.quantity || 1);
    var style         = getCurrentByogStyle();
    var convertedPrice = getConvertedPriceCents(Number(addonCfg.price));

    return {
      id:               Number(addonCfg.variant_id),
      quantity:         qty,
      title:            displayTitle,
      name:             displayTitle,
      product_title:    displayTitle,
      price:            convertedPrice,
      original_price:   convertedPrice,
      originalPrice:    convertedPrice,
      image:            img,
      featured_image:   img ? { src: img } : null,
      availableForSale: true,
      available:        true,
      currentlyNotInStock: false,
      requiresShipping: false,
      variantId:        Number(addonCfg.variant_id),
      variant_id:       Number(addonCfg.variant_id),
      product_id:       Number(addonCfg.product_id),
      sku:              (variantJson && variantJson.sku) ? variantJson.sku : "",
      selectedOptions:  [{ name: "Title", value: "Default Title" }],
      options:          ["Default Title"],
      option1:          "Default Title",
      public_title:     "Default Title",
      properties: {
        _addon_product:       true,
        _byog_parent_link:    parentItem.properties._uniqueGbbItemKey,
        _byog_addon_type:     "Personalisation",
        _byog_display_title:  displayTitle,
        _boxProduct:          style || (parentItem.properties && parentItem.properties._boxProduct) || ""
      }
    };
  }

  document.addEventListener("click", function (event) {
    var button = event.target && event.target.closest && event.target.closest(".gbbProductVariantAddButton");
    if (!button) return;
    var modal = button.closest(".gbbProductVariantModalContainer");
    if (!modal) return;
    var pid = modal.getAttribute("productid");
    var cfg = configForProduct(pid);
    var input = modal.querySelector('input[fieldkey="' + FIELDKEY_CHECKBOX + '"]');
    if (!cfg || !input || !input.checked) return;
    var before = read();
    var previous = {};
    var items = before && before.boxes && before.boxes[BOX] && before.boxes[BOX].items || [];
    items.forEach(function (item) {
      var key = item.properties && item.properties._uniqueGbbItemKey;
      if (key) previous[key] = Number(item.quantity || 0);
    });
    // Fetch first, then re-read storage on each attempt to preserve other add-ons.
    fetchVariantJson(cfg.variant_id).then(function (variant) {
      function insert(attempt) {
        var data = read();
        var box = data && data.boxes && data.boxes[BOX];
        var parentIndex = -1;
        if (box && Array.isArray(box.items)) {
          for (var i = box.items.length - 1; i >= 0; i--) {
            var item = box.items[i];
            var props = item.properties || {};
            var key = props._uniqueGbbItemKey;
            if (!props._addon_product && String(item.product_id) === String(pid) && key &&
                (!Object.prototype.hasOwnProperty.call(previous, key) || Number(item.quantity || 0) > previous[key])) {
              parentIndex = i;
              break;
            }
          }
        }
        if (parentIndex < 0) {
          if (attempt < 10) setTimeout(function () { insert(attempt + 1); }, 100);
          return;
        }
        var parent = box.items[parentIndex];
        if (hasAddonForParent(box.items, parent.properties._uniqueGbbItemKey, cfg.variant_id)) return;
        box.items.splice(parentIndex + 1, 0, buildAddonItem(parent, cfg, variant));
        recalcTotals(data);
        if (!write(data)) return;
        emitRefresh();
        if (typeof byogUpdateFooterTotalFromStorage === "function") byogUpdateFooterTotalFromStorage();
        if (typeof byogOptimisticInsertLatestAddonUnderParent === "function") byogOptimisticInsertLatestAddonUnderParent();
      }
      setTimeout(function () { insert(0); }, 80);
    });
  }, true);
})();
// END -- BYOG -- P15 / P20 PERSONALISATION FILTER AND ADD-ON
